var jqobj = document.getElementById('qactiondiv');

(function($){
    var partial = {
        'edit-partial': 'base-form-type-edit-partial',
        'readonly-partial': 'base-form-type-readonly-partial',
        'textarea': 'base-form-type-textarea',
        'select': 'base-form-type-select',
        'options': 'base-form-type-select-options',
        'checkbox-radio': 'base-form-type-radio-checkbox',
        'upload': 'base-form-type-upload',
        'upload-url': 'base-form-type-upload-url-partial',
        'text': 'base-form-type-default',
        'slider': 'base-form-type-slider',
        'image': 'base-form-type-image',
        'readomly-url': 'base-form-type-readonly-link',
        'pre': 'base-form-type-readonly-pre',
        'creative-brief': 'base-form-type-creativebrief',
        'readonly-hidden': 'base-form-type-readonly-hidden',
        'hidden': 'base-form-type-hidden'
    };

    var widgets = function(options) {

        if (options.isRender) {
            return false;
        }

        $.each(options, function(key, obj){
            if(!$.isEmptyObject(obj)) {
                switch(key) {
                    case 'jsonInput':
                        $.ezdia.jsonFields.create(obj);
                        break;
                    case 'editor':
                        $.ezdia.html.create(obj);
                        break;
                    case 'slider':
                        $.ezdia.slider.create(obj);
                        break;
                    case 'actionLink':
                        $.ezdia.fieldActionLinks.action(obj);
                        break;
                    case 'date':
                        $.ezdia.date.create(obj);
                        break;
                    case 'status':
                    case 'country':
                    case 'singlechoice':
                    case 'visualstatus':
                    case 'dropdown':
                        $.ezdia.singlechoice.create(obj);
                        break;
                    case 'multichoice':
                        $.ezdia.multichoice.create(obj);
                        break;
                    case 'group':
                        $.ezdia.typehead.create(obj);
                        break;
                    case 'tag':
                        $.ezdia.tagInput.create(obj);
                        break;
                    case 'listInput':
                    case 'groupField':
                        $.ezdia.listInput.create(obj, 'div[data-input="list"]');
                        break;
                    case 'inputtab':
                        $.ezdia.inputTab.create(obj, 'div[data-input="list"]');
                        break;
                    case 'tabletype':

                        break;
                    case 'integer':
                        $.ezdia.integer.create(obj);
                        break;
                    case 'boolean':
                        $.ezdia.boolean.create(obj);
                        break;
                    case 'url':
                        $.ezdia.url.create(obj);
                        break;
                    case 'text':
                        $.ezdia.textbox.create(obj);
                        break;
                    default:
                        break;
                }
            }

        });
        options.isRender = true;
        $('[data-toggle="popover"]').popover({
            template: $.ezdia.template.get('base-form-field-helper-popover')(),
            html: true
        });
    };

    var getClasses = function(column, helper){
        var cssCls = '';
        var metadata = column.config;

        if (helper.classes){
            cssCls += ' '+helper.classes;
        }
        if (column.edittype == 'html' && !column.editable) {
            cssCls += ' readonly-html';
        }

        if(metadata) {
            if (metadata.cssCls) {
                cssCls += ' '+metadata.cssCls;
            }
            if (metadata.videoHelp) {
                //videoHelp = metadata.videoHelp.join(':');
            }
        }

        return cssCls;
    };

    var setValidate = function(column){
        if (column.config && column.config.validate && column.editable) {
            $.ezdia.validate.init(column);
        }
    };

    var getValue = function(column, value){
        var context;
        if(column.edittype == 'filetype'){
            context = [];
            $.each(value.split(','), function(i, mval){
                var obj = {
                    href: mval.split("#")[0],
                    value: mval.replace("#", "")
                };
                var ext = obj.href.split('.').pop().toLowerCase();

                if ($.inArray(ext, ['gif','png','jpg','jpeg', 'tif', 'webp']) !== -1) {
                    obj.type = 'img';
                    obj.title = obj.value;
                    obj.src = obj.href;
                }

                context.push(obj);
            });

            column.data = context;
        } else if (!column.editable && value) {
            context = $.ezdia.sanitizer.script(value);
            context = $('<div>',{
                html: context
            }).html();

            value = context;
        }

        return value;
    };

    $.extend(this, {
        form: {
            options: {
            },
            init: function(options){
                this.options = {
                    widgets: {
                        text: {},
                        jsonInput: {},
                        editor: {
                            editor: {},
                            customer_config: null,
                            ctx: null,
                            userId: null,
                            trackChName: null,
                            accountName: null,
                            role: null
                        },
                        slider: {},
                        actionLink: {},
                        date: {},
                        url: {},
                        singlechoice: [],
                        multichoice: [],
                        group: [],
                        groupFields: [],
                        tag: [],
                        listInput: {},
                        inputtab: {},
                        tabletype: [],
                        integer: [],
                        boolean: []
                    },
                    templates: {
                        row: $.ezdia.template.get('base-form-field-row-wrapper'),
                        composite: $.ezdia.template.get('base-form-field-composite-wrapper'),
                        input: $.ezdia.template.get('base-form-field-row', partial),
                        helper: $.ezdia.template.get('base-form-field-helper'),
                        hidden: $.ezdia.template.get('base-form-type-hidden')
                    }
                };

                if (options) {
                    this.options.widgets.editor = $.extend({}, this.options.widgets.editor, options.editor);
                    this.options.templates = $.extend({}, this.options.templates, options.templates);
                }
            },
            create: function(obj){
                var self = this;
                var context = '';
                var id = $('#' + obj.id).empty().detach();
                var reqObj = {};
                var hastab = false;

                self.init(obj.editorOptions);

                $.each(obj.data, function(name, value) {
                    $.each(obj.cols, function(i, column) {
                        if(column.name == name){
                            value = getColDataString(column.edittype, value);
                            if(column.addon){
                                column.metadata = column.addon;
                            }
                            if (column.required) {
                                $.ezdia.validate.init(reqObj, column);
                                //reqObj[column.name] = 'required';
                            }
                            if (column.edittype == 'inputtab') {
                                hastab = true;
                            }
                            context = self.fields({
                                column: column,
                                cols: obj.cols,
                                value: value
                            });
                            id.append(context);
                            return false;
                        }
                    });
                });

                $('#' + obj.before).before(id);
                $.ezdia.validate.create(reqObj, obj.frm, hastab);

                this.createWidgets();
            },
            fields: function(obj){
                var options = this.options.widgets;
                var column = obj.column;

                column.value = getValue(column, obj.value);

                if(column.edittype == 'hidden'){
                    return this.getHiddenMarkup(column);
                }

                column.config = $.ezdia.getFieldsConfig(column);

                if(!column.editable && !obj.value && !obj.editForm){
                    return;
                }

                this.initWidgets(obj);
                $.ezdia.fieldActionLinks.init(options.actionLink, obj);
                setValidate(column);
                return this.getMarkup(obj);
            },
            initWidgets: function(obj){
                var options = this.options.widgets;
                var column = obj.column;

                switch(column.edittype) {
                    case 'composite':
                        this.composite(obj);
                        break;
                    case 'html':
                        $.ezdia.html.init(options.editor.editor, obj);
                        break;
                    case 'status':
                    case 'country':
                    case 'singlechoice':
                    case 'visualstatus':
                    case 'dropdown':
                        column.options = $.ezdia.singlechoice.getOptions(options.singlechoice, options.group, obj);
                        break;
                    case 'multichoice':
                        column.options = $.ezdia.multichoice.init(options.multichoice, obj);
                        break;
                    case 'slider':
                        $.ezdia.slider.init(options.slider, obj);
                        break;
                    case 'inputlist':
                    case 'groupField':
                        $.ezdia.listInput.init(options.listInput, obj);
                        break;
                    case 'group':
                        $.ezdia.typehead.init(options.group, obj);
                        break;
                    case 'role':
                        if (column.config && column.config.url) {
                            $.ezdia.typehead.init(options.group, obj);
                        }
                        break;
                    case 'tag':
                        $.ezdia.tagInput.init(options.tag, obj);
                        break;
                    case 'date':
                        $.ezdia.date.init(options.date, obj);
                        break;
                    case 'inputtab':
                        $.ezdia.inputTab.init(options.inputtab, obj);
                        break;
                    case 'json':
                        obj.widgets = true;
                        options.jsonInput[column.id || column.name] = obj;
                        break;
                    case 'textarea':
                        //obj.metadata = $.ezdia.textarea.get(obj);
                        break;
                    case 'filetype':
                        //obj.metadata = $.ezdia.filetype.getValue(obj);
                        break;
                    case 'integer':
                        $.ezdia.integer.init(options.integer, obj);
                        break;
                    case 'boolean':
                        $.ezdia.boolean.init(options.boolean, obj);
                        break;
                    case 'url':
                        $.ezdia.url.init(options.url, obj);
                        break;
                    default:
                        $.ezdia.textbox.init(options.text, obj);
                        break;
                }
            },
            getHiddenMarkup: function(column){
                var template = this.options.templates;
                return template.hidden(column).trim();
            },
            getMarkup: function(obj){
                var column = obj.column;
                var template = this.options.templates;
                var helperContext = $.ezdia.helperText(column);
                var helper = '';
                var context = '';
                var actionLinksMarkup = '';
                var actionLinksObj = this.options.widgets.actionLink[column.name];
                var edittype = '';

                column.classes = getClasses(column, helperContext);

                if(column.userInput){
                    edittype = column.edittype;
                    column.edittype = 'textfield';
                }

                if (helperContext.title) {
                    helper = template.helper(helperContext).trim();
                    column.helperCls = helperContext.classes;
                }

                var wrapper = template.row(column).trim();

                if (column.edittype == 'creativebrief') {
                    context = $.ezdia.creativeBrief.create({
                        key: column.name,
                        value: column.value,
                        grouptypeArray: this.options.widgets.group,
                        editable: column.editable,
                        edittype: column.edittype
                    });
                } else if(!column.path && ((column.edittype == 'role' && column.config && column.config.url) || column.edittype == 'group')){
                    context = $.ezdia.inputs.textboxs({column: column, value: column.value});
                } else {
                    context = template.input(column).trim();
                }

                if(obj.fieldsOnly) {
                    return context;
                    if(edittype) {
                        column.edittype = edittype;
                    }
                }

                if(actionLinksObj){
                    actionLinksObj.name = column.name;
                    actionLinksMarkup = $.ezdia.fieldActionLinks.create(actionLinksObj);
                }

                wrapper = $(wrapper);
                wrapper.find('[data-input]').append(context).append(helper).append(actionLinksMarkup);

                if(edittype) {
                    column.edittype = edittype;
                }

                return wrapper;
            },
            createWidgets: function(){
                var options = this.options.widgets;

                widgets(options);
            }
        }
    });
}).apply($.ezdia = $.ezdia || {}, [jQuery]);

(function($){

    var context = '';
    var jsonVal;
    var root = '';
    var template = null;
    var lstId = null;
    var preview = null;
    var localStorage = null;
    var widgetstype = 'json_widgets_obj';

    var createJson = function(json, path, value, type){
        var arr = path.split('.');
        var last = arr[arr.length - 1];

        $.each(arr, function(i, name){
            if (typeof json[name] === 'undefined') {
                if (last == name){
                    if (type == 'inputlist' || type == 'groupField' || type == 'inputtab' && value){
                        value = $.ezdia.getJsonObject(value);
                    }
                    json[name] = value;
                } else {
                    json[name] = {};
                }
            }
            json = json[name];
        });

    };

    var previewLink = function(){
        var obj= {
            name: root,
            json: {
                id: 'ez-json-preview-' + root,
                type: 'json',
                name: root
            }
        };
        return $.ezdia.fieldActionLinks.create(obj);
    };

    var createPreview = function(content, error){
        var html = content;
        var wrapperObj = $("#ez-json-field-preview-wrapper");

        if (!wrapperObj.length) {
            var divs = $('<div>',{
                id: 'ez-json-field-preview-wrapper'
            });
           $('body').append(divs);
        }
        wrapperObj = $("#ez-json-field-preview-wrapper");

        if (error) {
            html = 'Please Enter Some Data.';
        }

        wrapperObj.html(html);

        wrapperObj.dialog({
            modal: true,
            title: "Json Field Preview",
            width: 800,
            height: 450,
            buttons: {
                Cancel: function(){
                    $(this).dialog("close");
                }
            }
        });

    };

    $.extend(this, {
        jsonFields: {
            create: function(jsonObj){
                var self = this;

                $.ezdia.widgets.load(widgetstype);

                $.each(jsonObj, function(id, obj){
                    var elem = $('#' + id);
                    var row = elem.closest('[data-row="row"]');
                    var name= obj.column.name;
                    var context = self.render(obj);
                    var container = null;

                    row.hide();
                    row.after(context);

                    $.ezdia.widgets.create(widgetstype);

//                    if (!obj.widgets) {
//                        $.ezdia.form.createWidgets();
//                    }

                    container = $('#ez-json-field-container-' + name);
                    container.on('blur change', '[data-path]', function(){
                        $.proxy(self.update(container, elem, name), self);
                    });
                });
            },
            render: function(obj){
                var column = obj.column;
                var config = (typeof column.config === 'string') ? $.ezdia.getJsonObject(column.config) : column.config;
                var json;
                var html = null;
                
                jsonVal = $.ezdia.getJsonObject(obj.value);
                root = column.name;
                localStorage = obj.localStorage;

                if(config && config.fields) {
                    json = config.fields;
                } else {
                    json = config;
                }

                if(config && config.template) {
                    preview = config.template.read;
                    template = column.edittype ? config.template.edit : config.template.read;

                    if(template) {
                        template = $.ezdia.template.get(template, null, true);
                        context = {};
                    } else {
                        template = null;
                        context = '';
                    }
                } else {
                    context = '';
                }

                if (!column.edittype) {
                    return template(jsonVal);
                }

                html = this.getMarkup({
                    json: json,
                    init: true,
                    root: column.name,
                    jsonVal: jsonVal,
                    editable: column.editable
                });

                if(obj.tab) {
                    html = html.html();
                }

                return html;
            },
            getMarkup: function(obj){
                var self = this;
                var markup = null;

                $.each(obj.json || [], function(i, columns) {
                    var inputName = columns.inputName || columns.name;
                    var value = obj.jsonVal ? obj.jsonVal[inputName] : '';
                    var path = inputName;
                    var content = '';
                    var name = null;
                    var editable = null;
                    var edittype = null;

                    if (localStorage) {
                        columns.localStorage = localStorage;
                    }

                    if(columns.edittype == 'inputlist' || columns.edittype == 'groupField') {
                        value = value ? JSON.stringify(value) : '';
                    }
                    
                    if (!columns.inputName) {
                        columns.inputName = columns.name;
                    }

                    columns.path = obj.root + '.' + path;
                    name = (obj.root).replace(/\./ig, '_') + '_' + path;
                    columns.id = name;
                    columns.name = name;
                    lstId = columns.id;

                    if(columns.edittype == 'json'){
                        self.getMarkup({
                            json: columns.config,
                            root: columns.path,
                            jsonVal: value,
                            editable: obj.editable
                        });
                        return true;
                    }

                    if(!obj.editable && columns.editable == 'inherit') {
                        editable = columns.editable;
                        columns.editable = obj.editable;
                        edittype = columns.edittype;
                        if (edittype != 'html' && edittype != 'slider' && edittype != 'inputlist' && edittype != 'groupField' && edittype != 'inputtab'){
                            edittype = columns.edittype;
                            columns.edittype = 'hiddenInput';
                        }
                    }

//                    content = $.ezdia.form.fields({
//                        column: columns,
//                        cols: obj.json,
//                        value: value,
//                        fieldsOnly: template ? true : false
//                    });

                    content = $.ezdia.inputs.getMarkup({
                        column: columns,
                        cols: obj.json,
                        value: value,
                        fieldsOnly: template ? true : false
                    });

                    $.ezdia.widgets.init({
                        column: columns,
                        value: value
                    }, widgetstype);

                    if(editable) {
                        columns.editable = editable;
                        columns.edittype = edittype;
                    }

                    content = content ? content.prop('outerHTML') : '';

                    if (template) {
                        content = {
                            label: columns.label,
                            input: content
                        };
                        createJson(context, columns.path, content);
                    } else {
                        context += content;
                    }
                });

                if(obj.init){
                    if(preview) {
                        var previewlink = previewLink();
                        var id = '#ez-json-preview-' + root;

                        $('body').off(id).on('click', id, function(){
                            $.proxy(self.action(preview, $(this)), self);
                        });
                    }

                    if(template) {
                        context[obj.root][preview] = previewlink;
                        markup = template(context[obj.root]);
                    } else {
                        context = $('<div>', {
                            id: 'ez-json-field-container-' + obj.root,
                            class: 'ez-json-field-wrapper clearfix',
                            html: context
                        });
                        context.find('#row-'+ lstId + ' [data-input]').append(previewlink);
                        markup = context.unwrap();
                    }
                    return markup;
                }
            },
            action: function(template, elem){
                var error = false;
                var form = elem.parents('form');
                var name = elem.data('name');
                var inputs = form.find('[name='+ name +']');

                var json = inputs.val();
                    json = json ? $.ezdia.getJsonObject(json) : {};

                if($.isEmptyObject(json)) {
                    error = true;
                } else {
                    template = $.ezdia.template.get(template, null, true);
                    template = template(json[name]);
                }
                createPreview(template, error);
            },
            save: function(){

            },
            update: function(container, elem, name){
                var json = {};
                var value = null;
                var inputs = container.find('[data-path]');

                inputs.each(function(){
                    var self = $(this);
                    var path = self.data('path');
                    var type = self.data('type');
                    var value = '';

                    if (type === 'html') {
                        var elemId = self.attr('id');
                        value = tinyMCE.get(elemId).getContent();
                    } else if(type === 'radio') {
                        value = $("[name=" + self[0].name + "]:checked").val();
                    } else {
                        value = self.val();
                    }

                    createJson(json, path, value, type);

                });

                value = JSON.stringify(json[name]);
                elem.val(value);
            }
        }
    });
}).apply($.ezdia, [jQuery]);

(function($){
    var statusMap = $.ezdia.config.VISUAL_STATUS_MAPPING;
    var status = 'completed';
    var addedStatus = {};

    var getData = function(value, mval){
        var val = statusMap[mval];
        var obj = false;

        if (status == 'current') {
            status = 'pending';
        }
        if (!addedStatus[val]) {
            addedStatus[val] = 1;
            if (val == statusMap[value]) {
                status = 'current';
            }
            obj = {
                status: status,
                val: val,
                completed: (status == 'completed') ? true : false
            };
        }
        return obj;
    };

    $.extend(this, {
        VisualStatus: {
            getStatus: function (obj){
                var column = obj.column;
                var arr = [];

                if (column.config) {
                    $.each(column.config.options, function(i, mval) {
                        if (!mval) {
                            return;
                        }
                        var status = getData(obj.value, mval);
                        if (status) {
                            arr.push(status);
                        }
                    });
                }

                return arr;
            }
        }
    });
}).apply($.ezdia, [jQuery]);

(function($){

    var getSubClasses = function(edittype){
        var classes = '';

        switch(edittype) {
            case 'singlechoice':
            case 'visualstatus':
            case 'status':
            case 'dropdown':
            case 'country':
                classes = 'has-feedback-select';
                break;
            case 'filetype':
            case 'file':
                classes = 'has-feedback-file';
                break;
            case 'multichoice':
                classes = 'has-feedback-multichoice';
                break;
            case 'inputlist':
                classes = 'has-feedback-inputlist';
                break;
            default:
                break;
        }

        return classes;
    };

    $.extend(this, {
        helperText: function (column){
            var classes = '';
            var subClasses = '';

            var helperText = (column.helperText) ? $.ezdia.sanitizer.quotes(column.helperText) : '';
            var placeholder = (column.placeholder) ? $.ezdia.sanitizer.quotes(column.placeholder) : '';

            helperText = helperText || placeholder;

            if (helperText) {
                subClasses =  (column.editable) ? getSubClasses(column.edittype) : 'has-feedback-readonly';
                classes = 'has-feedback ' + subClasses;
            }

            return ({
                classes: classes,
                title: $('<div>', {html: helperText}).text(),
                content: helperText
            });

        }
    });
}).apply($.ezdia, [jQuery]);

(function($){
    var metadata = '';
    var getOptions = function(obj, id){
        metadata = obj.metadata || {};
        var pageParams = $.ezdia.config.pageParams;
        var url = (pageParams.ctx ? pageParams.ctx : '..');
        var options = {
            theme_advanced_toolbar_location: "top",
            theme_advanced_toolbar_align: "left",
            theme_advanced_statusbar_location: "bottom",
            theme_advanced_resizing: true,
            paste_strip_class_attributes: "all",
            paste_remove_spans: true,
            paste_text_sticky: true,
            element_format: "html",
            elements: "advimage",
            forced_root_block: false,
            verify_html: false,
            apply_source_formatting: false,
            width: "100%",
            height: !obj.readonly ? "250px" : '0',
            accountname: pageParams.account || '',
            role: pageParams.role || '',
            gecko_spellcheck: true,
            spellchecker_language: "en-us",
            spellchecker_languages: "+English=en-us",
            spellchecker_rpc_url: url + "/jmyspell-spellchecker",
            copypaste_var: obj.copypaste,
            keyword_density: obj.keyword,
            readonly: obj.readonly,
            relative_urls : false,
            remove_script_host : false,
            convert_urls : true,
            local_storage: obj.localStorage,
            auto_focus: false,
            entity_encoding: "raw",
            extended_valid_elements: "link[*], a[href|target=_blank]",
            custom_elements: "link",
            convertUrls: true,
            branding: false,
            file_picker_types: 'image', 
            file_picker_callback: $.ezdia.html.upload
        };

        if (obj.template) {
            //options.ezdia_template = $.ezdia.templateDb.get(metadata.content_template_name, metadata.content_template_type);
            options.ezdia_template = $.ezdia.getEditorTemplate(metadata.content_template_name, metadata.content_template_type);
        }

        if (!$.isEmptyObject(metadata)) {
            if (metadata.height) {
                options['height'] = metadata.height;
            }
            if (metadata.charcount) {
                options.charcount = metadata.charcount;
            }
            if (metadata.wordcount) {
                options.wordcount = metadata.wordcount;
            }
            if (metadata.badcontent) {
                options.badcontent = metadata.badcontent;
            }
            if (metadata.upload) {
                options.upload_file = true;
            }
            if (metadata.toggle) {
                options.toggle = true;
            }
            if (metadata.paste_as_text) {
                options.paste_as_text = true;
            }
            if (metadata.text_encoder) {
                options.text_encoder = true;
            }
            if (metadata.stc) {
                var userId = pageParams.userId;

                // TODO: REMOVE FIX THIS ONCE NEW CODE IS IMPLEMENTED
                if (!userId && ezdia.config.user) {
                  userId = ezdia.config.user.id;
                }

                options.ice = {user: {name: pageParams.trackChName, id: userId}};
                var htmlVal = $(id).html();
                if (htmlVal && htmlVal.indexOf("data-cid") !== -1 && htmlVal.indexOf("data-userid")) {
                    options.ice.isTracking = 1;
                } else {
                    options.ice.isTracking = 0;
                }
            }
            if(metadata.convertUrls === false){
                options.relative_urls = true;
                options.remove_script_host = true;
                options.convertUrls = false;
            }
        }

        extendOptions(options, metadata);

        var role = pageParams.role;
        var index = obj.name;
        if (customer_config) {
            var accountConfig = customer_config[$('#accountName').val()] && customer_config[$('#accountName').val()].tinymce;
            var roleConfig = customer_config[$('#accountName').val()] && customer_config[$('#accountName').val()][role]
                    && customer_config[$('#accountName').val()][role].tinymce;
            var elementConfig = customer_config[$('#accountName').val()] && customer_config[$('#accountName').val()][role]
                    && customer_config[$('#accountName').val()][role][index] &&
                    customer_config[$('#accountName').val()][role][index].tinymce;
            if (!elementConfig) {
                elementConfig = customer_config[$('#accountName').val()] && customer_config[$('#accountName').val()][index] &&
                        customer_config[$('#accountName').val()][index].tinymce;
            }
            $.extend(options, accountConfig, roleConfig, elementConfig);
        }

        return options;
    };

    var extendOptions = function(options, metadata) {
        var buttons;
        var obj = {
            branding: false,
            theme: 'modern',
            plugins: [ "advlist autolink lists link image charmap print preview anchor", "searchreplace visualblocks codemirror fullscreen", "insertdatetime media table paste", "ezdia"]
        };
        
        if ($.isEmptyObject(metadata)) {
            obj.toolbar1 = 'insertfile undo redo | styleselect | bold italic underline | bullist numlist outdent indent | link unlink | table image media | alignleft aligncenter alignright alignjustify spellchecker | code  fullscreen | forecolor backcolor';
            obj.toolbar2 = 'badcontent ezdiaUpload | ice_togglechanges ice_toggleshowchanges iceacceptall icerejectall iceaccept icereject | addComment removeCommentAll removeComment | templateselect | copypaste';
        } else {
            var buttonsA = [];
            var found = false;
            if (metadata.dfs) {
                buttonsA.push("bold,italic,underline");
                found = true;
            }
            if (metadata.dbl) {
                buttonsA.push("bullist");
                found = true;
            }
            if (metadata.dwc) {
                buttonsA.push("wordcount");
                found = true;
            }
            if (metadata.dcc) {
                buttonsA.push("charcount");
                found = true;
            }
            if (metadata.dsc) {
                buttonsA.push("spellchecker");
                found = true;
            }
            if (metadata.dlp) {
                buttonsA.push("link");
                buttonsA.push("unlink");
                found = true;
            }
            if (metadata.img) {
                buttonsA.push("image");
                found = true;
            }
            if (metadata.sbc) {
                buttonsA.push("badcontent");
                found = true;
            }
            if (found) {
                buttons = buttonsA.join(" ");
                obj.menubar = false;
                obj.toolbar1 = buttons;
            } else {
                obj.toolbar1 = 'insertfile undo redo | styleselect | bold italic underline | bullist numlist outdent indent | link unlink | table image media | alignleft aligncenter alignright alignjustify spellchecker | code  fullscreen | forecolor backcolor'
                obj.toolbar2 = 'badcontent ezdiaUpload | ice_togglechanges ice_toggleshowchanges iceacceptall icerejectall iceaccept icereject | addComment removeCommentAll removeComment | templateselect | copypaste';
            }

            if (metadata.htmlcopy) {
                options.setup = function(ed) {
                    ed.on('Init', function() {
                        ed.pasteAsPlainText = true;
                        ed.on('SaveContent', function() {
                            removeHighlightKeyword(ed.id);
                        });
                    });
                };
            }

            if (metadata.plainText) {
                options.setup = function(ed) {
                    ed.on('Init', function() {
                        ed.pasteAsPlainText = true;
                        ed.on('SaveContent', function() {
                            removeHighlightKeyword(ed.id);
                            ed.setContent(convertHtmlToPlainText(ed.id));
                        });
                    });
                };
            }

            if (metadata.sct) {
                options.comments = true;
            }
            if (metadata.stc) {
                obj.plugins.push('ice icesearchreplace');
            }
            if (metadata.languagetool) {
                var lt;

                if (typeof metadata.languagetool !== "object") {
                    lt = {
                        enable: true
                    };
                } else {
                    lt = metadata.languagetool;
                }

                options.languagetool = lt;
            } else {
                obj.plugins.push('spellchecker');
            }                  
        }

        if (options.readonly) {
            obj.toolbar1 = 'false';
            obj.toolbar2 = 'false';
            obj.menubar = false;
            obj.statusbar = false;        
            if (metadata.readonlyHeight) {
                options.readonlyHeight = metadata.readonlyHeight;
                options.height = metadata.readonlyHeight;
            } else {
                obj.plugins.push("autoresize");
                obj.autoresize_overflow_padding = 0;
                obj.autoresize_overflow_padding = 0;
                obj.autoresize_bottom_margin = 0;            
            }
        }
        
        $.extend(options, obj);
    };

    var getEditor = function(id){
        var ed = null;

        try {
            ed = tinymce.get(id);
            ed.getBody();
        }
        catch (err) {
            ed = null;
        }

        return ed;
    };

    $.extend(this, {
        html: {
            init: function (editorObject, obj) {
                var pageParams = $.ezdia.config.pageParams || {};
                var copypaste = false;
                var template = {};
                var column = obj.column;
                var metadata = column.config || {};

                if (!$.isEmptyObject(metadata)) {
                    if (metadata.copy) {
                        $.each(metadata.copy, function(i, mval) {
                            var field = mval;
                            var cols = obj.cols || pageParams.colModel || {};
                            $.each(cols, function(i, o){
                                if (o.name === field) {
                                    copypaste = copypaste || [];
                                    copypaste.push({
                                        fromfield: field,
                                        tofield: column.name,
                                        label: 'Paste ' + (o.label || field)
                                    });

                                    return false;
                                }
                            });
                        });
                    } else if (metadata.content_template_name || metadata.content_template_type) {
                        template = {
                            name: metadata.content_template_name,
                            type: metadata.content_template_type
                        };
                    } else if (metadata.plainText) {
                        obj.value = convertPlainTextToHtml(obj.value);
                    }
                }
                editorObject[column.id || column.name] = {
                    name: column.name,
                    metadata: metadata,
                    copypaste: copypaste ,
                    keyword: metadata.keyword || false,
                    template: !$.isEmptyObject(template) ? template : false,
                    readonly: !column.editable,
                    value: obj.value,
                    localStorage: column.localStorage || false
                };
            },
            create: function(editorObject){
                $.each(editorObject.editor, function(key, obj){
                    if (obj.value || !obj.readonly) {
                        var id = "#" + key;
                        var options = getOptions(obj, id);
                        if (getEditor(key)) {
                            delete tinyMCE.editors[key]; 
                        }
                        if(obj.metadata && obj.metadata.isGroupField) {
                            $.extend(options, {
                                "menubar": false, 
                                "toolbar": [ 'redo  undo | bold italic underline | bullist | alignleft aligncenter alignright alignjustify | outdent indent' ],
                                "max_height": 300,
                                "height" : '150px',
                                "setup": function(editor) {
                                    editor.on('keyup', function(e) {
                                      tinyMCE.triggerSave();
                                      $(id).trigger('change').trigger('keyup');
                                    });
                                }
                            });
                            $(id).tinymce(options);
                        } else {
                           $(id).tinymce(options);
                        }
                        $.ezdia.config.iseditor = true;
                    }
                });

            },
            toggle: function(id, action){
                var textarea = $('#' + id);
                var ed = tinymce.get(id);
                var $body = $(ed.getBody());
                
                if (action) {
                    textarea.attr('disabled', 'disabled');
                    ed.setMode('readonly');
                    $body.addClass('contentdelete');
                } else {
                    textarea.removeAttr('disabled');
                    ed.setMode('design');
                    $body.removeClass('contentdelete');
                }
            },
            upload: function(cb, value, meta) {
                var input = document.createElement('input');
                input.setAttribute('type', 'file');
                input.setAttribute('accept', 'image/*');    
                input.onchange = function() {
                    var file = this.files[0];
                    var reader = new FileReader();             
                    reader.readAsDataURL(file);
                    reader.onload = function () {
                        var type = file.type.split('/')[0];
                        
                        if (type !== 'image' && type !== 'video') {
                            alert('Error', 'Invalid file type.');
                            return;
                        }  
                        
                        if (file.size > 5000000) {
                            alert('Error', 'Max file size allow to 5MB');
                            return;
                        }

                        var pageParams = $.ezdia.config.pageParams;
                        var formData = new FormData();

                        formData.append("upload", file);
                        formData.append("accountName", pageParams.account || '');
                        formData.append("roleName", pageParams.role || '');

                        $.ajax({
                            type: "POST",
                            url: 'ImageUpload.htm',
                            data: formData,
                            dataType: 'json',
                            cache: false,
                            processData: false,
                            contentType: false,
                            success: function(response) {
                                cb(response.thumbnailUrl, { alt: file.name });
                            },
                            error: function(err) {
                                console.log('err', err);
                            }
                        });                    
                    };
                };
                input.click();
            }
        }
    });
}).apply($.ezdia, [jQuery]);

(function($){
    var arr = [];
    var other = false;
    var countryArray = ["Afghanistan", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas, The", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia & Herzegovina", "Botswana", "Brazil", "British Virgin Is.", "Brunei", "Bulgaria", "Burkina Faso", "Burma", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central African Rep.", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo, Dem. Rep.", "Congo, Repub. of the", "Cook Islands", "Costa Rica", "Cote d'Ivoire", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "East Timor", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Faroe Islands", "Fiji", "Finland", "France", "French Guiana", "French Polynesia", "Gabon", "Gambia, The", "Gaza Strip", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea, North", "Korea, South", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macau", "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia, Fed. St.", "Moldova", "Monaco", "Mongolia", "Montserrat", "Morocco", "Mozambique", "Namibia", "Nauru", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "N. Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russia", "Rwanda", "Saint Helena", "Saint Kitts & Nevis", "Saint Lucia", "St Pierre & Miquelon", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome & Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "Spain", "Sri Lanka", "Sudan", "Suriname", "Swaziland", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Togo", "Tonga", "Trinidad & Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks & Caicos Is", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela", "Vietnam", "Virgin Islands", "Wallis and Futuna", "West Bank", "Western Sahara", "Yemen", "Zambia", "Zimbabwe"];

    var hasOther = function(str){
        return (str.toLowerCase() === 'other') ? true : false;
    };

    var status = function (obj) {
        arr = [];
        other = false;
        obj.value = obj.value || '';
        $(statuses).each(function(l) {
            var status = statuses[l] && statuses[l].trim();
            if (!status) {
                return;
            }
            other = hasOther(status);
            arr.push({
                value: status,
                label: status,
                selected: (status == obj.value.trim()) ? true : false
            });
        });

        return arr;
    };

    var country = function (obj) {
        arr = [];
        $.each(countryArray, function(i, mval) {
            var value = obj.value || '';
            arr.push({
                value: mval,
                label: mval,
                selected: (value.trim() == mval.trim()) ? true : false
            });
        });

        return arr;
    };

    var singlechoice = function (obj) {
        var column = obj.column;
        arr = [];
        var value = obj.value ? obj.value : '';

        column.config.options = column.config.options || {};

        $.each(column.config.options, function(idx, mval) {
            if (!mval) {
                return;
            }
            arr.push({
                value: idx,
                label: mval,
                selected: (value.trim() == idx.trim()) ? true : false
            });
        });

        return arr;
    };
    
    var getSettings = function (select) {   
        var placeholder = select.attr('placeholder');
        var deselect = select.data('deselect');
        var settings = {
            placeholder_text: placeholder || '',
            disable_search_threshold: 10,
            allow_single_deselect: false
        };
        
        var option = select.find('option:first-child');
        
        if (deselect == undefined) {
            deselect = true;
        }
        
        if (!option.val() && deselect) {
            settings.allow_single_deselect = true;
        }
        
        return settings;
        
    };

    $.extend(this, {
        singlechoice: {
            getOptions: function (selectObject, typeheadObject, obj) {
                var column = obj.column;
                var opt = '';
                column.config = column.config || {};

                if(column.config.userInput){
                    typeheadObject.push({
                        column: column,
                        id: column.id || column.name,
                        metadata: column.config,
                        edittype: column.edittype
                    });
                    column.userInput = true;
                } else {

                    switch(column.edittype) {
                        case 'status':
                            opt = status(obj);
                            break;
                        case 'country':
                            opt = country(obj);
                            break;
                        default:
                            opt = singlechoice(obj);
                    }
                    if (column.editable) {
                        selectObject.push({
                            name: column.id || column.name,
                            options: opt,
                            config: column.config
                        });                        
                    }
                }

                return opt;
            },
            create: function(selectObject){
                $.each(selectObject, function(i, obj){
                    var config = obj.config || {}; 
                    var select = $('#' + (obj.id || obj.name));

                    if (!select.length || select[0].tagName !== 'SELECT') {
                      return;
                    }

                    var defaultOpt = getSettings(select);
                    
                    if (config.sorting) {
                        select.sortItems({
                            order: typeof config.sorting === "boolean" ? 'asc' : config.sorting
                        });
                    }

                    select.chosen(defaultOpt).on("chosen:showing_dropdown chosen:hiding_dropdown", function(e) {
                        var chosen_container = $( e.target ).next( '.chosen-container' );
                        var win = $(window);
                        var dropdown        = chosen_container.find( '.chosen-drop' );
                        var dropdown_top    = dropdown.offset().top - win.scrollTop();
                        var dropdown_height = dropdown.height();
                        var viewport_height = win.height();

                        if (dropdown_top + dropdown_height > viewport_height) {
                            dropdown.css({
                                top: -dropdown_height
                            });
                        } else {
                            dropdown.css({
                                top: ""
                            });
                        }
                    });
                });
            },
            view: function(obj) {
                var column = obj.column;
                var value = obj.value;
                var config = $.ezdia.getFieldsConfig(column);

                if ( typeof value !== "undefined" && value !== null ) {
                    value = value.toString();
                }

                if (value && config && config.options) {
                    $.each(config.options, function(mval, label){
                        if (mval == value) {
                            value = label;
                            return false;
                        }
                    });
                }

                return value;
            },
            toggle: function (id, action){
                var $id = $('#' + id);
                var parent = $id.closest('[data-row="input"]');
		var elem = parent.find('.tt-input');
                
                if (!elem.length) {
                    elem = $id;
                }
                
                if (action) {
                    elem.attr('disabled', 'disabled');
                } else {
                    elem.removeAttr('disabled');
                }
            },
            setValue: function(obj){
                var select = $(obj.id);
                var chosen = select.data('chosen');
                
                if (select.attr('multiple')) {
                  var val = obj.value ? obj.value.split(',') : ''
                  select.val(val);
                } else {
                  select.val(obj.value);
                }

                if (chosen) {
                    select.trigger("chosen:updated");
                }
                
                select.trigger('change');
            }
        }
    });
}).apply($.ezdia, [jQuery]);

(function($){
    var setValue = function(key, value){
        $('#' + key + '_slider_value').text(value || 0);
        var parentEl = $('#' + key + '_slider');
        var textId = $('#' + key);
        var isColor = textId.attr('data-color');
        if (value && isColor == 'true') {
            if (value <= 3) {
                parentEl.switchClass({add: 'writer-bad', remove: ['writer-average', 'writer-good']});
            } else if (value <= 6) {
                parentEl.switchClass({add: 'writer-average', remove: ['writer-bad', 'writer-good']});
            } else {
                parentEl.switchClass({add: 'writer-good', remove: ['writer-bad', 'writer-average']});
            }
        }
    }

    $.extend(this, {
        slider: {
            init: function(sliderObject, obj) {
                var column = obj.column;
                var metadata = column.config;
                var min = 0;
                var max = 10;
                var color = false;

                sliderObject[column.id || column.name] = obj.value;
                if (metadata.setColor) {
                    color = true;
                }
                if (metadata.min) {
                    min = metadata.min;
                }
                if (metadata.max) {
                    max = metadata.max;
                }

                column.slider = {
                    min: min,
                    max: max,
                    color: color
                };
            },
            create: function(sliderObject){
                $.each(sliderObject, function(index, value) {
                    var id = $('#' + index);
                    var min = id.attr('data-slider-min');
                    var max = id.attr('data-slider-max');
                    
                    if(!id.length) {
                        return;
                    }

                    var minDiv = $('<div>',{
                        class: 'slider-min-value',
                        html: min
                    });
                    var maxDiv = $('<div>',{
                        class: 'slider-max-value',
                        html: max
                    });

                    id.bootstrapSlider({
                        id: index + '_slider',
                        tooltip: 'hide'
                    }).on('slide', function(e) {
                        setValue(index, e.value);
                    });
                    $('#' + index + '_slider').on('mouseup', function() {
                        var sliderInput = id;
                        var value = sliderInput.data('bootstrapSlider').getValue();
                        setValue(index, value);
                    }).append(minDiv)
                            .append(maxDiv);

                    setValue(index, value);
                });

            },
            toggle: function(id, action){
                var elem = $('#' + id);
                
                if (action) {
                    elem.bootstrapSlider('disable');
                } else {
                    elem.bootstrapSlider('enable');
                }
            }
        }
    });
}).apply($.ezdia, [jQuery]);

(function($){
    var valueArray = [];

    var isSelected = function(key){
        var index = $.inArray(key, valueArray);

        if(index !== -1) {
            valueArray.splice(index, 1);
            return true;
        } else {
            return false;
        }
    };

    var getOptions = function (obj) {
        var column = obj.column;
        var arr = [];

        if (!column.config) {
            column.config = {};
        }

        if(obj.value && typeof obj.value === 'string') {
            valueArray = obj.value.split('##');
        }

        column.config.options = column.config.options || {};
        $.each(column.config.options, function(key, mval) {
            if (!mval) {
                return;
            }
            arr.push({
                value: key,
                label: mval,
                selected: isSelected(key)
            });
        });

        if(valueArray.length){
            $.each(valueArray, function(i, mval) {
                if (!mval) {
                    return;
                }
                arr.push({
                    value: '##' + mval,
                    label: mval,
                    selected: true
                });
            });
        }
        return arr;
    };

    var update = function(to, from){
        var value = from.val();

        to.val(value ? ('##' + value.join('##') + '##') : '').trigger('change');
    };

    var createlink = function(id, inputElem, elem) {
        var ids = 'ms-' + id;
        var a = $('<a>', {
            href: "javascript:void(0)",
            text: 'Add custom value'
        }).on('click', function(){
            addOptions(id, inputElem, elem);
        });
        var div = $('<div>', {
            html: a,
            class: 'ez-add-multi-user-opt'
        });
        $('#' + ids).append(div);

    };

    var addOptions = function(id, inputElem, elem) {
        var selectId = $('#' + id);
        var wrapperObj = $("#addMultiChoiceOptWrapper");
        var newOptValue = '';

        if (!wrapperObj.length) {
            var wrapper = $('<div>', {
                id: 'addMultiChoiceOptWrapper'
            });
            $('body').append(wrapper);
            wrapperObj = $("#addMultiChoiceOptWrapper");
        }

        wrapperObj.html('<div class="add-multi-choice-opt"> <textarea class="add-new-option" id="addMultiChoiceOpt">' + newOptValue + '</textarea></div>');

        wrapperObj.dialog({
            modal: true,
            title: "Add custom value",
            width: '300',
            height: '200',
            buttons: {
                "Ok": function() {
                    var selectOptVal = $('#addMultiChoiceOpt').val();
                    if ($.trim(selectOptVal)) {
                        var selectVal = selectOptVal;
                        var optIndex = $('#ms-' + id + ' .ms-selectable .ms-hover').index();
                        if (optIndex > 0) {
                            optIndex--;
                        } else {
                            optIndex = 0;
                        }
                        selectId.append('<option value="'+ selectVal +'">'+selectVal+'</option>');
                        selectId.multiSelect('refresh')
                        .multiSelect('select', [selectVal]);

                        $(this).dialog("close");
                        createlink(id,inputElem, elem);
                        update(inputElem, elem);
                    }
                },
                "Cancel": function() {
                    $(this).dialog("close");
                }
            }
        });

    };

    $.extend(this, {
        multichoice: {
            init: function(multichoiceObject, obj){
                var column = obj.column;

                multichoiceObject.push({
                    key: column.name,
                    id: column.id || column.name,
                    value: obj.value,
                    column: column
                });

                return getOptions(obj);
            },
            create: function(multichoiceObject){
                $.each(multichoiceObject, function(i, obj) {
                    var column = obj.column;
                    var config = column.config || {};
                    var id = obj.id ? obj.id : obj;
                    var elem = $("#multichoice-" + id);
                        elem = elem.length ? elem : $("#" + id + '-multichoice');
                    var inputElem = $('#' + id);

                    elem.multiSelect({
                        classes: "form-control",
                        afterSelect: function() {
                            update(inputElem, elem);
                        },
                        afterDeselect: function() {
                            update(inputElem, elem);
                        }
                    });
                    inputElem.val(obj.value);

                    if (config.userInput) {
                        createlink('multichoice-'+id, inputElem, elem);
                    }
                });
            },
            createlink: function(id, inputElem, elem){
                createlink(id, inputElem, elem);
            },
            view: function(data, column){
                var content = '';
                var config = column.config || {};
                var options = config.options || {}
                
                if (data) {
                    $.each(data.split('##'), function(i, mval){
                        if(!mval) {
                            return true;
                        }
                        
                        if(['eza_alert_urls_form', 'eza_alert_rules_form', 'eza_alert_form'].includes($.ezdia.config.pageParams.formType) ) {
                            content +=  options[mval] || mval;
                        } else {
                            content += $('<span>', {
                                class: 'label label-default',
                                text: options[mval] || mval
                            }).prop('outerHTML') + '&nbsp;';
                        }

                    });
                }

                return content;
            },
            toggle: function (id, action){
                var parent = $('#' + id).closest('[data-row="input"]');
                var options = parent.find('#ms-multichoice-' + id).find('li:not("ms-optgroup-label")');
                var addoptions = parent.find('.ez-add-multi-user-opt');
                
                if (action) {
                    options.addClass('disabled');
                    addoptions.hide();
                } else {
                    options.removeClass('disabled');
                    addoptions.show();
                }
            }
        }
    });
}).apply($.ezdia, [jQuery]);

(function($){

    var list = function(value){
        var content = '';
        var ul = $('<ul>', {
            class: 'list-unstyled unstyled-input-list'
        });

        $.each(value, function(i, obj){
            var str = ''
            var type_of = typeof obj === 'object';
                    
            if (type_of && !obj.value) {
                return;
            } else {
                str = type_of ? obj.value : obj;
            }

            var li = $('<li>', {
                html: str
            });

            ul.append(li);

        });

        content = ul.prop('outerHTML');

        return content;
    };

    var pills = function (value){
        var content = '';

        $.each(value, function(i, obj){
            if (!obj.value) {
                return;
            }

            var span = $('<span>', {
                html: obj.value,
                class: 'label label-default white-space-normal'
            });

           content += span.prop('outerHTML') + '&nbsp;';

        });

        return content;

    };
   
    var createGroupFieldsPreview = function (obj){
        var listObj = {};
        var value = '';
        var textarea = $.ezdia.inputs.textarea(obj, true);
        var elem = '';
        
        $('body').append(textarea);
        
        this.init(listObj, obj);
        this.create(listObj);
        
        elem = $('textarea#'+obj.column.name);
        value = elem.val();
        
        elem.remove();
        
        return value;
    };

    $.extend(this, {
        listInput: {
            init: function(listObject, obj){
                var column = obj.column;
                var obj = {
                    editable: column.editable,
                    config: column.config,
                    preview: obj.preview
                };

                if(column.edittype == 'inputlist') {
                    obj.mode = 'list';

                    if(column.config && column.config.array){
                        obj.storageType = true;
                    }
                } else {
                    obj.mode = 'group';
                    obj.fields = column.config.fields;
                    obj.removeDisabled = column.removeDisabled ? column.removeDisabled: false ;
                }
                
                listObject[column.id || column.name] = obj;
            },
            create: function(listObject, sortItem){
                $.each(listObject, function (key, obj){
                    var id = $('textarea#'+key);
                    id.inputList(obj);
                    if (sortItem){
                        id.closest('.inputs').sortable({
                            items: sortItem,
                            cursor: 'move'
                        });
                    }
                });
            },
            view: function (obj, type){
                var value = obj.value;
                var content = '';
                value = $.ezdia.getJsonObject(value);
                
                if (value) {
                    if (obj.column.edittype == 'inputlist') {
                        if (type == 'pills') {
                            content = pills(value);
                        } else {
                            content = list(value);
                        }
                    } else if (obj.preview) {
                        content = createGroupFieldsPreview.call(this, obj);
                    }                    
                }

                return content;
            },
            toggle: function (id, action, type){
                var parent = $('#' + id).closest('[data-row="input"]');
                var btns;
                var elem;
                
                if (type == 'groupField') {
                    elem = parent.find('[id^=' + id + ']');
                    btns = parent.find('td .btn-group');
                } else {
                    elem = parent.find('input[type=text]');
                    btns = parent.find('.input-group-btn');
                }
                
                if (action) {
                    elem.attr('disabled', 'disabled');
                    btns.hide();
                } else {
                    elem.removeAttr('disabled');
                    btns.show();
                }
            }
        }
    });
}).apply($.ezdia, [jQuery]);

(function($){

    var list = function(value){
        var content = '';
        var ul = $('<ul>', {
            class: 'list-unstyled unstyled-input-list'
        });

        $.each(value, function(i, obj){
            if (!obj.value) {
                return;
            }

            var li = $('<li>', {
                html: obj.value
            });

            ul.append(li);

        });

        content = ul.prop('outerHTML');

        return content;
    };

    var pills = function (value){
        var content = '';

        $.each(value, function(i, obj){
            if (!obj.value) {
                return;
            }

            var span = $('<span>', {
                html: obj.value,
                class: 'label label-default white-space-normal'
            });

           content += span.prop('outerHTML') + '&nbsp;';

        });

        return content;

    };
    
    var createGroupFieldsPreview = function (obj){
        var listObj = {};
        var value = '';
        var textarea = $.ezdia.inputs.textarea(obj, true);
        var elem = '';
        
        $('body').append(textarea);
        
        this.init(listObj, obj);
        this.create(listObj);
        
        elem = $('textarea#'+obj.column.name);
        value = elem.val();
        
        elem.remove();
        
        return value;
    };

    $.extend(this, {
        attributes: {
            init: function(listObject, obj){
                var column = obj.column;
                var obj = {
                    editable: column.editable,
                    config: column.config
                };

                if(column.edittype == 'inputlist') {
                    obj.mode = 'list';

                    if(column.config && column.config.array){
                        obj.storageType = true;
                    }
                } else {
                    obj.mode = 'group';
                    obj.fields = column.config.fields;
                }

                listObject[column.id || column.name] = obj;
            },
            create: function(listObject, sortItem){
                $.each(listObject, function (key, obj){
                    var id = $('textarea#'+key);
                    id.inputList(obj);
                    if (sortItem){
                        id.closest('.inputs').sortable({
                            items: sortItem,
                            cursor: 'move'
                        });
                    }
                });
            },
            view: function (obj, type){
                var value = obj.value;
                var content = '';
                value = $.ezdia.getJsonObject(value);

                if (value) {
                    if (obj.preview) {
                        content = createGroupFieldsPreview.call(this, obj);
                    } 
                }

                return content;
            },
            toggle: function (id, action, type){
                var parent = $('#' + id).closest('[data-row="input"]');
                var btns;
                var elem;
                
                if (type == 'groupField') {
                    elem = parent.find('[id^=' + id + ']');
                    btns = parent.find('td .btn-group');
                } else {
                    elem = parent.find('input[type=text]');
                    btns = parent.find('.input-group-btn');
                }
                
                if (action) {
                    elem.attr('disabled', 'disabled');
                    btns.hide();
                } else {
                    elem.removeAttr('disabled');
                    btns.show();
                }
            }
        }
    });
}).apply($.ezdia, [jQuery]);

(function($){
    var altFormat = 'yy-mm-dd';
    
    function setDateRange(id, name, type) {
        $('[name="' + name + '"]').on('change', function() {
            var date = $.datepicker.parseDate(altFormat, this.value );
            $(id).datepicker( "option", type, date );
        });
    }

    $.extend(this, {
        date: {
            init: function(dateObject, obj){
                var column = obj.column;

                dateObject[column.id || column.name] = column;
            },
            create: function(dateObject){
                var widgettype = 'datetimepicker';
                
                $.each(dateObject, function (key, column){
                    var id = "#" + (column.id || key);
                    var hiddenId = column.hiddenId || column.name + '-date-value';
                    var elem = $('#' + hiddenId);
                    var config = column.config || {};
                    var obj = {
                        controlType: 'select',
                        oneLine: true,
                        timeFormat: 'hh:mm TT',
                        dateFormat: 'MM d, yy',
                        altFormat: altFormat,
                        altTimeFormat: 'HH:mm',
                        altFieldTimeOnly: false,
                        altField: "#" + hiddenId
                    };

                    if(!config.backDate) {
                        obj.minDate = 0;
                    }

                    if(typeof config.displayTime !== 'undefined' && !config.displayTime) {
                        widgettype = 'datepicker';
                    }

                    if(config.startDate) {
                        setDateRange(id, config.startDate, 'maxDate');
                    }

                    if(config.endDate) {
                        setDateRange(id, config.endDate, 'minDate');
                    }

                    $(id)[widgettype](obj).on('change', function() {
                        elem.trigger('change');
                    });
                });
            },
            view: function(config, value){
                //var format = "MMMM Do YYYY";
                var date = value;
                var format = "MMMM DD, YYYY hh:mm A";
                if(value){
                    var year = value.split("-")[0]; 
                    if(year=='0000' || year =='9999' || year=='9998'){
                        return '';
                    }
                }
                if (config && config.format) {
                    format = config.format;
                }

                if (value) {
                    date = moment(value).format(format);
                }

                if (date == 'Invalid date') {
                    date = value;
                }

                return date;
            },
            toggle: function (id, action){
                var parent = $('#' + id).closest('[data-row="input"]');
                var elem = parent.find('.hasDatepicker');
                
                if (action) {
                    elem.attr('disabled', 'disabled');
                } else {
                    elem.removeAttr('disabled');
                }
            },
            setValue: function() {
                
            }
        }
    });
}).apply($.ezdia, [jQuery]);

(function($){

    $.extend(this, {
        integer: {
            init: function(intObject, obj){
                var column = obj.column;

                intObject.push(column);
            },
            create: function(intObject){
                $.each(intObject, function (i, column){
                    var key = column.id || column.name;
                    var id = $("#" + key);
                    var config = column.config || {};
                    var obj = {};

                    if (!config.decimal) {
                        obj.decimal = false;
                    }

                    if (config.decimal && config.decimalPlaces) {
                        obj.decimalPlaces = config.decimalPlaces;
                    }

                    id.numeric(obj);
                });
            }
        }
    });
}).apply($.ezdia, [jQuery]);

(function($){
    var limit = 10;

    var enableMatchAll = function (bloodhound) {
        var _get = bloodhound.index.get;
        bloodhound.index.get = function(query) {
            if(!query || query === '') {
                return this.datums;
            } else {
                return _get.call(this, query);
            }
        }
    };

    var getConfig = function(config){
        var obj = {};
        var isarr = null;
        var options = null;

        if (config) {
            isarr = $.isArray(config);

            if(typeof config === 'string' || isarr) {
                obj.options = {};
                options = !isarr ? config.split("##") : config;

                $.each(options, function(idx, mval) {
                    if (mval && mval.toLowerCase() !== 'other') {
                        obj.options[mval] = mval;
                    }
                });
            } else {
                obj = config;
            }
        }

        return obj;

    };

    var getOptions = function(options){
        options = options || {};
        limit = 0;
        options = $.map(options, function(mval, key) {
            if (mval) {
                limit++;
                if (typeof mval === 'object') {
                    return {label: mval.label, value: mval.value};
                } else {
                    return {label: mval, value: key};
                }
            }
        });

        return options;
    };

    var getDisplayVal = function(val, config){
        var options = config.options || {};
        var value = val;

        $.each(options, function(key, mval) {
            if (mval) {
                if (typeof mval === 'object' && (mval.value == val)) {
                    value = mval.label;
                    return false;
                } else if (key == val) {
                    value = mval;
                    return false;
                }
            }
        });

        return value;

    };

    var getURL = function(url, compute, validate_unique){
        var index = url.indexOf('?');
        var dynamic_url = compute || validate_unique || false;
        
        if (dynamic_url && index == -1) {
            url = url + "?";
        } else if (index != -1) {
            url = url + (dynamic_url ? "&":"&term=");
        } else {
            url = url + "?term=";
        }
        
        return url;
    };
    
    var updateUrl = function(config, remote, isBasicSearch) {
        var self = this;
        var urlParam = config.urlParam;
        var query = '';
        
        this.url = remote.url;
        this.query = [];
        
        $.each(urlParam.reference, function(i, obj){
            var elem = $('[name='+ obj.name + ']') || $('#' + obj.name);
            var value = '';
            var query = '';
            
            if (isBasicSearch) {
                var elem = $('#sys-basic-search-query-display-wrap').find('[name$="__' +  obj.name +'"]');
            }

            if (obj.type == 'account') {
                value = $.ezdia.config.pageParams.account;
            } else if (obj.type == 'role') {
                value = $.ezdia.config.pageParams.role;
            } else if (obj.type == 'urlParam') {
                value = ezdia.util.getUrlParams( obj.name);
            } else if (elem.length) {
                value = elem.val() || '';
                bindQueryChange.call(self, {
                    elem: elem, 
                    searchKey: obj.searchKey, 
                    remote: remote,
                    index: i
                });
            } else if (!isBasicSearch && !elem.length) {
                value = $('#' + obj.name).text() || '';
                value = value.trim();
            }
         
            query = obj.searchKey + '=' + value;
            self.query.push(query);
            
        });
        
        setUrl.call(this, remote);
    };
    
    var bindQueryChange = function(obj) {
        var self = this;
        obj.elem.on('change', function(){
            var value = this.value;
            var query = obj.searchKey + '=' + value;
            self.query[obj.index] = query;

            setUrl.call(self, obj.remote);
        });         
    };
    
    var setUrl = function(remote, unique) {
        remote.url = this.url + this.query.join('&') + '&term=';
    };
    
    var setUniqueParam = function(element, remote){
        var validate_key = $.ezdia.config.validate_key.unique;
        var url =  this.url;
        var unique_array = element.data(validate_key.key);
        var unique_array_copy = [];
        var index = 0;
        
        if (this.query) {
            url += this.query.join('&') + '&';
        }
        
        if (typeof unique_array === 'undefined') {
            console.warn(element.attr('name') + ' missing unique array!');
        } else {
            index = element.data(validate_key.index);
            unique_array_copy = unique_array.slice(0);
            
            if (index !== -1) {
                unique_array_copy.splice(index, 1);
            }
            
            unique_array_copy = unique_array_copy.filter(function(v){return v!==''});
            
            url += 'ignoreAttrList=' + unique_array_copy + '&';
        }
        
        remote.url = url + 'term=';
    };
    
    var group = function(obj){
        limit = 10;
        var column = obj.column || {};
        var placeholder = obj.column.placeholder || '';
        var id = $('#' + obj.id);
        var hiddenId = $('#' + obj.id + '-date-value');
        var config = column.config || getConfig(obj.metadata);
        column.config = config;
        var urlParam = config.urlParam;
        var validate_unique = config.validate_rules && config.validate_rules.unique || false;
        var options = null;
        var bloodhoundObj = {
            datumTokenizer: Bloodhound.tokenizers.obj.nonword('label'),
            queryTokenizer: Bloodhound.tokenizers.nonword,
            limit: config.limit || limit
        };
        
        var extendedConfig = $.extend({
            cache: true
        }, config);
        
        if(config.url){
            bloodhoundObj.remote = {
                url: getURL(config.url, urlParam, validate_unique),
                replace: function(url, query) {
                    return url + encodeURIComponent(query);
                },
                ajax: {
                    type: "POST",
                    dataType: "json"
                },
                filter: function(list) {
                    return $.map(list, function(obj) {
                        return {
                            label: obj.label, 
                            value: obj.value, 
                            type: obj.colModel || obj.config
                        };
                    });
                },
                cache: extendedConfig.cache
            };
        } else {
            options = getOptions(config.options);
            bloodhoundObj.limit = limit;
            bloodhoundObj.local = options || [];
        }
        var source = new Bloodhound(bloodhoundObj);
        source.initialize();

        id.typeahead({
            hint: true,
            highlight: true,
            minLength: 0
        }, {
            name: 'source',
            displayKey: 'label',
            source: source.ttAdapter(),
            templates: {
              empty: '<div class="tt-empty">Search query not found.</div>'
            }
        }).on("click", function() {
            var ev = $.Event("keydown");
            ev.keyCode = ev.which = 40;
            $(this).trigger(ev);
            return true;
        }).on('typeahead:selected', function(object, datum) {
            $(this).trigger('typeahead:_done', [object, datum]);
        }).on('typeahead:autocompleted', function(object, datum) {
            $(this).trigger('typeahead:_done', [object, datum]);
        }).on('change', function() {
            $(this).trigger('typeahead:_changed');
        }).on('typeahead:_changed', function() {
            var label = id.data('label');
            var value = id.typeahead('val');
            var doneActive = id.data('_done');
            
            if(doneActive) {
                return;
            }

            if ((!config.userInput && !doneActive) && !column.isSearch) {
                if(!value && label != value) {
                    id.typeahead('val', value);
                    hiddenId.val((value || '')).trigger('change');
                } else if (value && label != value) {
                    id.typeahead('val', label);
                    hiddenId.val((value || '')).trigger('change');
                }
            } else {
                hiddenId.val((value || '')).trigger('change');
            }
            
            id.typeahead('close');
        }).on('typeahead:_done', function(evt, object, datum) {
            id.data('_done', true);
            id.typeahead('close').blur();
            hiddenId.val((datum.value || '')).data('inherit-obj', datum.type).trigger('change');
            id.data('_done', false);
        });
        
        placeholder = placeholder || id.attr('placeholder');
        id.attr('placeholder', placeholder);        
        id.on('focus', function(){
            var label = id.typeahead('val');
            id.data('label', label);
            id.select();
            id.removeAttr('placeholder');
        }).on('blur', function (){
            id.attr('placeholder', placeholder);
        });
        
        if (urlParam) {
            updateUrl.call(id, config, source.remote, obj.isBasicSearch);         
        } 
        
        if (validate_unique) {
            id.url = id.url || source.remote.url;
            id.on('focus', function(){
                setUniqueParam.call(id, hiddenId, source.remote);  
            });            
        }
        if(!config.url){
            enableMatchAll(source);
        }
    };
    
    var clickOnMenu = function(elem){
        var menu = elem.data('ttTypeahead').dropdown.$menu;
        var isvisible = menu.is(':visible');
        
        if (isvisible) {
            menu.find('.tt-suggestion').first().trigger('click');
             elem.off('typeahead:opened');
        } else {
            setTimeout(function(){ 
                clickOnMenu(elem);
            }, 1000);
        }
    };

    $.extend(this, {
        typehead:{
            init: function (typeheadObject, obj) {
                var column = obj.column;

                typeheadObject.push({
                    isBasicSearch: column.isSearch,
                    column: column,
                    id: column.id || column.name,
                    metadata: column.config,
                    edittype: column.edittype
                });
            },
            create: function(typeheadObject){
                $.each(typeheadObject, function(i, obj) {
                    var column = obj.column || {};
                    
                    if (column.editable) {
                        group(obj);
                    }

                });
            },
            view: function(val, config){
                var value = '';
                config = config || {};

                if (config.url) {
                    value = val;
                } else {
                    value = val ? getDisplayVal(val, config) : '';
                }

                return value;
            },
            update: function(typeheadObject){
                $("#" + typeheadObject.id).typeahead('destroy');
                this.create(typeheadObject);
            },
            destroy: function(id){
                $("#" + id).typeahead('destroy');
            },
            toggle: function (id, action, type){
                var $id = $('#' + id)
                var parent = $id.closest('[data-row="input"]');
		var elem = parent.find('.tt-input');
                
                if (type == 'role' && !elem.length) {
                    elem = $id;
                }
                
                if (action) {
                    elem.attr('disabled', 'disabled');
                } else {
                    elem.removeAttr('disabled');
                }
            },
            setValue: function(obj){
                var elem = $(obj.id);
                elem.off('typeahead:opened').on('typeahead:opened', function() {
                    clickOnMenu(elem);
                });
                elem.eq(0).val(obj.value).trigger("input");
            }
        }
    });
}).apply($.ezdia, [jQuery]);

(function($){
    var showHistory = function(column){
        var obj = {};
        var config = column.config;
        if(config) {
            if (config.showhistory) {
                obj = {
                    name: column.name,
                    type: 'history',
                    edittype: column.edittype,
                    label: column.label,
                    id: 'ez-show-history-' + column.id || column.name,
                    hidden: false
                };
            } else {
                obj = false;
            }
        }
        return obj;
    };

    var toggleLinks = function(self){
        var type = self.data('type');
        var name = self.data('name');
        var wrapper;

        if (self.hasClass('selected')) {
            self.removeClass('selected');
            if(type == 'workflow'){
                wrapper = $('#ez-workflow-history-wrapper-' + name);
                if(wrapper.length){
                    wrapper.collapse('hide');
                    wrapper.parents('[data-input="block"]').removeClass('show-workflow-history');
                }

            } else if(type == 'history'){
                wrapper = $('#ez-show-history-wrapper-' + name);
                if(wrapper.length){
                    wrapper.collapse('hide');
                    wrapper.parents('[data-input="block"]').removeClass('show-show-history');
                }
            }

            return false;
        } else {
            self.addClass('selected').siblings().removeClass('selected');
            if(type == 'workflow'){
                $('#ez-show-history-wrapper-' + name).remove();
            } else if(type == 'history'){
                $('#ez-workflow-history-wrapper-' + name).remove();
            }
            return true;
        }
    };

    $.extend(this, {
        fieldActionLinks:{
            init: function (actionLinkObject, obj) {
                var column = obj.column;
                var history = false;
                var actionLinkObj = {};

                if (column.config) {
                    history = showHistory(column);
                    if(history){
                        actionLinkObj.history = history;
                    }
                }
                if (obj.value && column.edittype == 'email') {
                    actionLinkObj.profile = {
                        key: column.name,
                        type: 'profile',
                        profileUrl: 'profileUrl'
                    };
                }
                if (column.edittype == 'workflow') {
                    actionLinkObj.workflow = {
                        key: column.name,
                        type: 'workflow',
                        id: 'ez-workflow-histroy-' + column.id || column.name
                    };
                }
                if(!$.isEmptyObject(actionLinkObj)){
                    actionLinkObject[column.name] = actionLinkObj;
                }
            },
            create: function(actionLinkObject){
                var template = $.ezdia.template.get('base-form-field-action-link');
                return template(actionLinkObject);
            },
            action: function(actionLinkObject){
                $.each(actionLinkObject, function(key, obj){
                    if(obj.history){
                        $('#'+ obj.history.id).off('.ez-field-action-link').on('click.ez-field-action-link', function(){
                            var self = $(this);
                            var historyObj = {
                                name: self.data('name'),
                                label: self.data('label'),
                                edittype: self.data('edittype'),
                                hidden: self.data('hidden')
                            };

                            if (toggleLinks(self)){
                                fetchContentHistory(historyObj);
                            }

                        });
                    }
                    if(obj.workflow){
                        $('#'+ obj.workflow.id).off('.ez-field-action-link').on('click.ez-field-action-link', function(){
                            var self = $(this);
                            var name = self.data('name');

                            if (toggleLinks(self)){
                                fetchWorkFlowHistory(name);
                            }

                        });
                    }
                });
            }
        }
    });
}).apply($.ezdia, [jQuery]);

(function ($) {

    var enableMatchAll = function (bloodhound) {
        var _get = bloodhound.index.get;
        bloodhound.index.get = function(query) {
            if(!query || query === '') {
                return this.datums;
            } else {
                return _get.call(this, query);
            }
        };
    };

    var tagInput = function(obj){
        var id = $('#' + obj.id);
        var config = obj.metadata || {};
        var validateRules = config.validate_rules || {};
        var options = null;
        var tagsObj = {};
        var typeaheadObj = {};
        var isLocalOpt = false;
        var bloodhoundObj = {
            datumTokenizer: Bloodhound.tokenizers.obj.nonword('label'),
            queryTokenizer: Bloodhound.tokenizers.nonword
        };
        var limit = 10;

        if(config.url){
            bloodhoundObj.remote = {
                url: config.url + "?term=",
                replace: function(url, query) {
                    return url + query;
                },
                ajax: {
                    type: "POST",
                    dataType: "json"
                },
                filter: function(list) {
                    return $.map(list, function(obj) {
                        return {
                            label: obj.label,
                            value: obj.value
                        };
                    });
                }
            };
        } else {
            isLocalOpt = true;
            options = config.options || {};

            options = $.map(options, function(label, value) {
                limit++;
                return {
                    value: value,
                    label: label
                };
            });

            bloodhoundObj.local = options || [];
            bloodhoundObj.limit = limit;
        }

        var source = new Bloodhound(bloodhoundObj);
        source.initialize();

        typeaheadObj = {
            name: 'source',
            displayKey: 'label',
            source: source.ttAdapter()
        };

        if(config.userInputDisable){
            tagsObj.itemValue = 'value';
            tagsObj.itemText = 'label';
        } else {
            typeaheadObj.valueKey = 'label';
        }

        if (isLocalOpt) {
            tagsObj.typeaheadjs = [{
                minLength: 0,
                highlight: true
            } , typeaheadObj];
        } else {
            tagsObj.typeaheadjs = typeaheadObj;
        }


        id.tagsinput(tagsObj);

        var inputs = id.tagsinput('input');

        if (!inputs) {
            return false;
        }
        
        if (validateRules.tagemail) {
            var from = id.parents('form');
            id.on('beforeItemAdd', function(e) {
                var validate = $.validator.methods.email.call({
                    optional: function() { 
                        return !e.item;
                    }
                }, e.item, id);

                if (!validate) {
                    e.cancel = !validate;
                    setTimeout(function() { 
                        inputs.val(e.item);
                        inputs.attr('size', (e.item.length || 0) + 4);
                        var value = id.data('email') || '';
                        
                        id.val(value+','+e.item);
                        var validator = from.data('validator');
                        validator.element('#' + obj.id);
                    }, 0);
                }

            });
            id.on('itemAdded', function(e) { 
                var validator = from.data('validator');
                var value = id.val();
                id.data('email', value);
                validator.element('#' + obj.id);
            });  
        }
        

        
        id.on('itemRemoved', function(e) {
            if (e.options && e.options.keyCode === 8) {
                inputs.focus();
                setTimeout(function(){ 
                    inputs.val(e.item); 
                    inputs.attr('size', e.item.length);
                }, 0);
            }
        });

        inputs.off('blur').on('blur', function(e){
            var ttThis = $(this).data('ttTypeahead');
            var elem = $(this);

            if (!config.userInputDisable) {
                var value = this.value;
                id.tagsinput('add', value);
            }

            elem.val('');
            ttThis.isActivated = false;
            ttThis.dropdown.empty();
            ttThis.dropdown.close();

        }).on("click", function() {
            var ev = $.Event("keydown");
            ev.keyCode = ev.which = 40;
            $(this).trigger(ev);
            return true;
        });
        
        if (isLocalOpt) {
            enableMatchAll(source);
        }

        if(config.userInputDisable){
            addValue(id, options);
        }
    };

    var addValue = function(id, options){
        var data = id.val();
        if(!data){
            return false;
        }

        $.each(data.split(','), function(index, value) {
            var obj = {"value": value};
            if (options) {
                $.each(options, function(i, mval){
                    if (value == mval.value) {
                        obj.label = mval.label;
                        return false;
                    }
                });
            }
            id.tagsinput('add', obj);
        });
    };

    var getLabel = function(str, options){
        var arr = [];
        $.each(str.split(','), function(index, value) {
            var found = false;
            if (options) {
                $.each(options, function(i, mval){
                    if (value == mval.value) {
                        arr.push(mval.label);
                        found = true;
                        return false;
                    }
                });
                if (!found) {
                    arr.push(value);
                }
            }
        });

        return arr;
    };

    $.extend(this, {
        tagInput: {
            init: function (tagInputObject, obj) {
                var column = obj.column;

                tagInputObject.push({
                    column: column,
                    id: column.id || column.name,
                    metadata: column.config,
                    edittype: column.edittype
                });
            },
            create: function(tagInputObject){
                $.each(tagInputObject, function(i, obj) {
                    tagInput(obj);
                });
            },
            view: function(column, str){
                var content = '';
                var config = column.config || {};
                var options = config.options;
                var freeInput = config.userInputDisable;

                if (str) {
                    if (freeInput) {
                        str = getLabel(str, options);
                    } else {
                        str = str.split(",");
                    }

                    $.each(str, function(i, mval){
                        if (!mval) {
                            return;
                        }
                        var label = $('<span>', {
                            text: mval,
                            class: 'label label-info'
                        });

                        content += label.prop('outerHTML') + '&nbsp;';
                    });
                }

                return content;
            },
            addValue: function(elem, value) {
                var tagsinputObj = elem.tagsinput()[0];

                if (tagsinputObj.options.freeInput) {
                    elem.tagsinput('add', value);
                } else {
                    elem.tagsinput('add', {
                        "label": value,
                        "value": value
                    });
                }
               
            }
        }
    });
}).apply($.ezdia, [jQuery]);

(function ($) {

    $.extend(this, {
        wordsum: {
            init: function (wordsumObj, obj) {
                var column = obj.column;
                var template = $.ezdia.template.get('base-form-type-wordsum', {'wordsum-partial-hidden': 'base-form-type-hidden'});
                var config = column.config || {};

                column.id = column.id || column.name;

                wordsumObj.push({
                    id: column.id,
                    fields: config.fields,
                    count: config.count
                });

                return template(column);
            },
            create: function(wordsumObj){
                $.each(wordsumObj, function(i, obj){
                    var elem = $('#' + obj.id);
                    elem.data('ez.wordsum', {});
                });
            }
        }
    });
}).apply($.ezdia, [jQuery]);

(function($){

    $.extend(this, {
        inputTab: {
            init: function(tabObject, obj){
                var column = obj.column;
                var obj = {
                    editable: column.editable,
                    fieldConfig: column.config
                };

                tabObject[column.id || column.name] = obj;
            },
            create: function(tabObject, sortItem){
                $.each(tabObject, function (key, obj){
                    var id = $('textarea#'+key);
                    id.inputTab(obj);
//                    if (sortItem){
//                        id.closest('.inputs').sortable({
//                            items: sortItem,
//                            cursor: 'move'
//                        });
//                    }
                });
            }
        }
    });
}).apply($.ezdia, [jQuery]);

(function($){
    var selClass = "btn-success active";
    var delClass = "btn-active active";

    var toggle = function(e){
        var elem = $(e.currentTarget);
        var id = elem.data('id');

        if (elem.hasClass('active')) {
            return false;
        }

        var checkBox = $('#' + id);
        var value = checkBox.prop("checked");

        checkBox.prop("checked", !value);

        if (!value) {
            elem.addClass(selClass).siblings().removeClass(delClass);
            checkBox.val(1);
        } else {
            elem.addClass(delClass).siblings().removeClass(selClass);
            checkBox.val(0);
        }
    };

    $.extend(this, {
        boolean: {
            init: function(booleanObject, obj){
                var column = obj.column;

                booleanObject.push(column.id || column.name);
            },
            create: function(booleanObject){
                $.each(booleanObject, function (i, id){
                    $('[data-id=' + id + ']').off('.ez.boolean').on('click.ez.boolean', toggle);
                });
            }
        }
    });
}).apply($.ezdia, [jQuery]);

(function($){

    var validate = function (name){
        var dummyInput = $('[name="' + name + '_dummy"]');

        dummyInput.rules('add', {
            required: true,
            messages: {
                required: 'Please click on link'
            }
        });
    };

    var searchBtn = function(inputs, key, value, editable, clickValidate){
        var input = '<input type="text" id="' + key + '_dummy" name="' + key + '_dummy" style="display: none">';
        var id = key + '-googlesearch';
        var button = $('<button>', {
            type: "button",
            id: id,
            html: '<i class="fa fa-search"></i>',
            class: "btn btn-link",
            disabled: !value
        }).prop('outerHTML');

        if (editable) {
            var span = $('<span>', {
                class: "input-group-btn",
                html: button
            });

            inputs.wrap('<div class="input-group"></div>').after(span)
                    .closest('[data-row="row"]').addClass('ez-input-search');
        } else {
            inputs.append(button).append(input);
            if (clickValidate) {
                validate(key);
            }
        }

        return $('#' + id);

    };
    
//    var computeRule = function (ruleObj) {
//        var content = '';
//        var len = this.length -1 ;
//        var re = null;
//        var pattern = ruleObj || '[^\\w]';
//        var modifiers = '';
//        
//        if (typeof pattern !== 'string') {
//            pattern = ruleObj.pattern;
//            modifiers = ruleObj.modifiers;
//        }
//        
//        re = new RegExp(pattern, "ig");
//        
//        $.each (this, function(i) {
//            var space = '';
//            var value = this.value;
//
//            if (i < len) {
//                space += ' ';
//            }
//
//            if (value) {
//                content += value.trim() + space;
//            }
//
//        });
//        
//        if (content) {
//            content = content.replace(re, modifiers).toLowerCase();
//        }
//
//        return content;
//        
//    };
//    
//    var computeTemplates = function(template){
//        var context = {};
//        
//        $.each (this, function() {
//            context[this.name] = this.value;
//        });
//
//        return template(context);
//        
//    };
//    
//    var updatePaypalId = function (element) {
//        var $this = $(this);
//        var value = $this.val();
//        
//        $.ajax({
//            type: "POST",
//            url: 'fetchPaypalID.htm',
//            data: 'email=' + value,
//            dataType: 'json',
//            success: function(response) {
//                if (response.success) {
//                    element.val(response.msg).attr('readonly', 'readonly');
//                } else {
//                    element.val("").removeAttr('readonly');
//                }
//            }
//        });
//    };
//    
//    var multiplication = function(element) {
//        var val = 1;
//        
//        $.each (this, function() {
//            val *= +$(this).val();
//        });
//        
//        element.val(val);
//    };
//    
//    var computeMethods = {
//        updatePaypalId: updatePaypalId,
//        multiplication: multiplication,
//    };
//
//    var compute = function(key, config){
//        var compute = config.compute ;
//        var reference = compute.reference;
//        var elem = $('#' + key);
//        var watch = null;
//        var template = null;
//        var event = compute.event || 'keyup';
//        var type = 'ez.compute';
//        
//        if (typeof reference  !== 'string') {
//            reference = reference.join("], [name=");
//        }
//        
//        watch = $('[name='+ reference + ']');
//        
//        if (compute.template) {
//            template = $.ezdia.template.get(compute.template, '', true);
//            event = 'change';
//        }
//        
//        if (reference.length && elem.length) {
//            watch.off(type).on(event + '.' + type, function() {
//                var value = '';
//                if (compute.template) {
//                    value = computeTemplates.call(watch, template);
//                    elem.val(value);
//                } else if (compute.fn) {
//                    computeMethods[compute.fn].call(watch, elem, compute);
//                } else {
//                    value = computeRule.call(watch, compute.rule);
//                    elem.val(value);
//                }
//            });
//            
//            elem.off(type).on('change' + '.' + type, function() {
//                watch.off(type);
//                elem.off(type);
//            });
//        }
//
//    };

    var search = function(key, mval, editable, url, clickValidate){
        var inputs = $('#' + key);
        var btn = searchBtn(inputs, key, mval, editable, clickValidate);

        if (url) {
            var srctemplate = Handlebars.compile(url);
        }

        btn.off('click').on('click', function(){
            var value = editable ? inputs.val() : mval;
            if (value) {
                value = encodeURIComponent(value);
                value = value.replace(/'/g, '%27');
            }
            var query = null;

            if (srctemplate) {
                query = srctemplate({
                    text: value
                });
            } else {
                query = 'https://www.google.com/search?q=' + value;
            }

            window.open(query, '_blank');

        });

        if (!editable) {
            btn.off('mousedown').on('mousedown', function(){
                var dummyInput = $('[name="' + key + '_dummy"]');
                var frm = dummyInput.closest('form');
                $.ezdia.validate.unhighlight(frm, dummyInput);
                dummyInput.rules('remove');
            });
        }

        if (editable) {
            inputs.off('keyup').on('keyup', function(){
                var value = this.value;
                if(value) {
                    btn.removeAttr('disabled');
                } else {
                    btn.attr('disabled', 'disabled');
                }
            });
        }
    };

     var total = function(column){
        var fields = column.config.total || [];
        var fld = $('[name="'+ column.name +'"]');

        $.each(fields, function(i, name){
            var elem = $('[name="'+ name +'"]');
            if (elem.length) {
                elem.on('change', function(){
                    updateTotal(fields, fld);
                });
            }
        });
        updateTotal(fields, fld);
     };

     var updateTotal = function(fields, elem){
        var sum = 0;

        $.each(fields, function(i, name){
            var val = $('[name="'+ name +'"]').val();
                val = val ? parseFloat(val) : 0;

            sum += val;
        });

        elem.val(sum);
     };

    $.extend(this, {
        textbox: {
            init: function(textObject, obj){
                var column = obj.column;
                var config = column.config || {};

                if (config.search || config.compute|| config.total) {
                    textObject[column.id || column.name] = obj;
                }

            },
            create: function(textObject){
                $.each(textObject, function (key, obj){
                    var column = obj.column;
                    var config = column.config;

//                    if (config.compute) {
//                        compute(key, config);
//                    }

                    if (config.search) {
                        search(key, obj.value, column.editable, config.search_url, config.clickValidate);
                    }
                    
                    if (config.total) {
                        total(column);
                    }
                });
            }
        }
    });
}).apply($.ezdia, [jQuery]);

(function($){

    var viewBtn = function(inputs, key, value){
        var id = key + '-openurl';
        var button = $('<button>', {
            type: "button",
            id: id,
            html: '<i class="fa fa-share-square-o"></i>',
            class: "btn btn-link",
            disabled: !value
        }).prop('outerHTML');

        var span = $('<span>', {
            class: "input-group-btn",
            html: button
        });

        inputs.wrap('<div class="input-group"></div>').after(span)
                .closest('[data-row="row"]').addClass('ez-input-url');

        return $('#' + id);

    };

    var openLink = function(key, mval){
        var inputs = $('#' + key);
        var btn = viewBtn(inputs, key, mval);

        btn.off('click').on('click', function(){
            var value = inputs.val();
            var query = '';

            if (value.indexOf("http://") !== 0 && value.indexOf("https://") !== 0 && value.indexOf("//") !== 0) {
                query = '//';
            }

            query += value;

            window.open(query, '_blank');

        });

        inputs.off('keyup').on('keyup', function(){
            var value = this.value;
            if(value) {
                btn.removeAttr('disabled');
            } else {
                btn.attr('disabled', 'disabled');
            }
        });
    };

    var view = function(obj) {
        var column = obj.column || {};
        var config = column.config || {};
        var content = '';
        var linkHref = '';
        var reg = /<\s*a*\s[A-Za-z0-9\s\=\"\'\%\&\:\/\.\_\-\/\?]*>\s*[^ ]*\s*<\/a>/;
        var value = $.trim(obj.value);
        var target = config.target === '_self' ? '_self' : '_blank'; 
        if (reg.test(value)) {
            linkHref = $(value).attr('href');
            if (linkHref.indexOf("http://") === -1 && linkHref.indexOf("https://") === -1) {
                value = $(value).attr('href', "http://" + linkHref);
                value = $('<div>', {html: value}).html();
            }
            if (!$(value).attr('target')) {
                value = $(value).attr('target', target);
                content = $('<div>', {html: value}).html();
            } else {
                content = value;
            }
        } else {
            linkHref = (value.indexOf("http://") === -1 && value.indexOf("https://") === -1) ? "http://" + value : value;
            content = '<a href="' + linkHref + '" target="' + target + '">' + value + '</a>';
        }
        
        if (column.name) {
            var input = '<input type="text" id="' + (column.id || column.name) + '_dummy" name="' + column.name + '_dummy" style="display: none">';

            content = $(content).attr('id', column.name + '_url');
            content = content.prop('outerHTML');

            return content + input;            
        } else {
            return content;
        }

    };

    var validate = function (name){
        var dummyInput = $('[name="' + name + '_dummy"]');
        var frm = dummyInput.closest('form');

        dummyInput.rules('add', {
            required: true,
            messages: {
                required: 'Please click on link'
            }
        });

        $('#' + name + '_url').on('mousedown', function(){
            $.ezdia.validate.unhighlight(frm, dummyInput);
            dummyInput.rules('remove');
        });
    };

    $.extend(this, {
        url: {
            init: function(initObj, obj){
                var column = obj.column;

                initObj[column.id || column.name] = obj;

                if(!column.editable) {
                    return view(obj);
                }
            },
            create: function(urlObj){
                $.each(urlObj, function (key, obj){
                    var column = obj.column || {};
                    var config = column.config || {};

                    if (column.editable) {
                        openLink(key, obj.value);
                    } else if (config.clickValidate){
                        validate(key);
                    }

                });
            },
            view: function(obj){
                var column = obj.column || {};
                var content = '';

                if(column.editable) {
                    content = $.ezdia.inputs.textbox(obj);
                } else {
                    content = view(obj);
                }

                return content;
            },
            formatter: function(cm, template){
                var self = this;
                cm.formatter = function(v) {
                    return template({
                        dataVal: encodeURI($.trim(v)),
                        val: self.view({
                            value: v
                        })
                    }).trim();
                };
                cm.unformat = function(v, o, cell) {
                    var content = $('.col-max-height', cell).data('value');
                    return decodeURI(content);
                };
            }
        }
    });
}).apply($.ezdia, [jQuery]);

(function($){

    var view = function(obj){
        var viewVal = obj.value;
        var config = obj.column.config || {};
        var options = config.options;
        var content = [];

        if (!viewVal) {
            return '';
        }

        viewVal = viewVal.split('##');
        
        $.each(viewVal, function(i, aval) {
            if (aval) {
                var label = options[aval] || aval;
                content.push(label);
            }
        });

        return content.join(', ');
    };

    var checkbox = function(id){
        var checkboxs = $('[type=checkbox][data-id=' + id + ']');

        checkboxs.on('click', function(){
            var value = "";
            $.each(checkboxs, function(){
                if (this.checked ) {
                    value +=  value ? '##' : '';
                    value +=  this.value;
                }
            });
            $('#' + id).val(value).trigger('change');
        });
    };

    var restore = function(obj){
        var viewVal = obj.value;
        var column = obj.column;

        if (!viewVal) {
            return '';
        }

        var id = column.id || column.name;
        $('[type=checkbox][data-id=' + id + ']').prop('checked', false);
        viewVal = viewVal.substring(2).split('##');

        $.each(viewVal, function(i, mval){
            $('[type=checkbox][data-id=' + id + '][value=' + mval + ']').prop('checked', true);
        });

        $('#' + id).val(obj.value).trigger('change');
    };

    $.extend(this, {
        checkbox: {
            init: function(initObj, obj){
                var column = obj.column;

                initObj[column.id || column.name] = obj;
            },
            create: function(checkboxObj){
                $.each(checkboxObj, function (key){
                     checkbox(key);
                });
            },
            view: function(obj){
                var column = obj.column || {};
                var content = '';

                if(column.editable && !obj.gridview) {
                    content = $.ezdia.inputs.radioCheck(obj);
                } else {
                    content = view(obj);
                }

                return content;
            },
            formatter: function(cm, template){
                var self = this;
                cm.formatter = function(v) {
                    return template({
                        dataVal: v,
                        val: self.view({
                            column: cm,
                            value: v,
                            gridview: true
                        })
                    }).trim();
                };
                cm.unformat = function(v, o, cell) {
                    return $('.col-max-height', cell).data('value');
                };
            },
            restore: function(obj){
                restore(obj);
            }
        }
    });
}).apply($.ezdia, [jQuery]);

(function($){

    var view = function(obj){
        var viewVal = obj.value;
        var column = obj.column;
        var config = column.config || {};

        $.each(config.options || {}, function(mval, label){
            if (mval == obj.value) {
                viewVal = label;
                return false;
            }
        });

        return viewVal;
    };

    $.extend(this, {
        radio: {
            view: function(obj){
                var column = obj.column || {};
                var content = '';

                if(column.editable && !obj.gridview) {
                    content = $.ezdia.inputs.radioCheck(obj);
                } else {
                    content = view(obj);
                }

                return content;
            },
            formatter: function(cm, template){
                var self = this;
                cm.formatter = function(v) {
                    return template({
                        dataVal: v,
                        val: self.view({
                            column: cm,
                            value: v,
                            gridview: true
                        })
                    }).trim();
                };
                cm.unformat = function(v, o, cell) {
                    var data = $('.col-max-height', cell).data('value');

                    if (data != null && data != '') {
                        data = String(data);
                    }

                    return data;
                };
            }
        }
    });
}).apply($.ezdia, [jQuery]);

(function($){
    var STATUS_MAPPING = $.ezdia.config.STATUS_CSS_MAPPING;

    var getClass= function(value){
        var classes = STATUS_MAPPING[value];
        return classes ? classes : '';
    };

    $.extend(this, {
        status: {
            view: function(obj){
                return $('<span>', {
                    class: 'label ' + getClass(obj.value),
                    html: obj.value
                }).prop('outerHTML');
            }
        }
    });
}).apply($.ezdia, [jQuery]);

(function ($) {
    var template = null;
    var prefix = 'ez-comment-field-list-';

    var toogle = function(){
        var elem = $(this);
        var show = elem.data('show');
        var container = elem.data('container');
        var list = $('#' + container).find('li[data-hide]');
        var more = elem.find('.more');
        var less = elem.find('.less');

        if (show == 'more') {
            more.hide();
            less.show();
            elem.data('show', 'less');
            list.attr('data-hide', '');
        } else {
            less.hide();
            more.show();
            elem.data('show', 'more');
            list.attr('data-hide', 'hide');
        }
    };

    $.extend(this, {
        comment: {
            init: function (initObj, obj){
                var column = obj.column || {};

                if (!initObj['_fields']) {
                    initObj['_fields'] = {};
                }

                initObj['_fields'][column.name] = obj;
            },
            create: function(commentObj){
                template = $.ezdia.template.get('base-form-type-comments');
                commentObj._fields = commentObj._fields || {};
                $.each(commentObj._fields, function(key, obj){
                    var column = obj.column;
                    var editable = obj.editable || column.editable;
                    var id = prefix + column.name;
                    var list = commentObj._list[key] || null;
                    var context = {
                        id: prefix + column.name
                    };
                    var content = '';
                    var elem = $('[name=' + key + ']');
                    
                    if (list) {
                        context.list = list;
                        context.more = list.length > 3 ? true : false;
                        content = template(context);
                    }

                    if (editable) {
                        elem.before(content).attr('placeholder', 'Add your thoughts...').val('');
                    } else if (!content) {
                        elem.closest('[data-row="row"]').remove();
                    } else {
                        elem.replaceWith(content);
                    }

                    $('[data-container="'+ id +'"]').on('click', function(){
                        toogle.call(this);
                    });
                });
            }
        }
    });
}).apply($.ezdia, [jQuery]);

(function($){

    $.extend(this, {
        entity: {
            init: function(entityObject, obj){
                var column = obj.column;
                var name = column.name;

                entityObject[name] = obj;
            },
            create: function(entityObject){
                $.each(entityObject, function(name, obj){
                    var column = obj.column;
                    var id = $('#' + (column.id || name));
                    obj.column.entity = typeof obj.column.entity === 'string' ? $.ezdia.getJsonObject(obj.column.entity): obj.column.entity;  
                    id.entity(obj);

                });
            }
        }
    });
}).apply($.ezdia, [jQuery]);


(function($){

    $.extend(this, {
        entityLabeling: {
            init: function(entityObject, obj){
                entityObject.push(obj);
            },
            create: function(entityObject){
                $.each(entityObject, function(i, obj){
                    var column = obj.column;
                    var id = $('#' + (column.id || column.name));
                    id.entityLabeling(obj);

                });
            },
            view: function(intiObj) {
                try {
                    intiObj.value = JSON.stringify(intiObj.value)
                } catch(ex) {
                    intiObj.value = '';
                }
                return $.ezdia.inputs.textarea(intiObj, true);
            },
            localStorageView: function(intiObj) {
                var value = ezdia.util.jsonParse(intiObj.value);
                var column = intiObj.column;
                var htmlContent = $('[name="' + column.name +'"]').entityLabeling('getLabeledContent', value);
                
                console.log(htmlContent)
                return htmlContent;
            },
            setValueAndUpdate: function(props) {
                var element = props.element;
                var value = props.value;
                
                $(element).entityLabeling('refresh', value);
            }
        }
    });
}).apply($.ezdia, [jQuery]);

(function($){
    var imgExtension = ['gif','png','jpg','jpeg', 'tif', 'webp'];
    var wrapperID = 'ez-ui-upload-delete-popover-wrapper';
    var deletetemplate = null;
    var elements = null;
    var pageParams = {};
    
    var check = function (value) {
        return (typeof value != 'undefined') && !value;
    };
    
    var getWrapper = function () {
        var elem = $('#' + wrapperID);
        var wrapper = null;
        
        if (!elem.length) {
        
            wrapper = $('<div>',{
                id: wrapperID
            });

           $('body').append(wrapper);
           
           elem = $('#' + wrapperID);
        }
        
        return elem;
    };
    
    var getOptions = function(name, obj) {
        var column = obj.column;
        var config = column.config || {}; 
        var optionsObj = {};
        var extendObj = {};
        
        elements = document.getElementById('ui_' + name);
        pageParams = $.ezdia.config.pageParams;
        extendObj = {
            ui_element: document.getElementById(column.id || name),
            element: elements,
            ui_column: column,
            request: {
                params: {
                    accountName: pageParams.account,
                    roleName: pageParams.role,
                    itemId: getGridSelRow(),
                    fieldName: name,
                    tab: pageParams.tab
                }
            },
            cors: {
                expected: true
            }
        };
        
        obj.value = $.ezdia.getJsonObject(obj.value);
        
        if (check(config.delete) || !column.editable) {
            extendObj.deleteFile = {
                enabled: false
            };
        }
        
        if (config.validation) {
            extendObj.validation = config.validation;
        }
        
        optionsObj = $.extend(true, {}, this.defaults, extendObj);

        return optionsObj;
    };
    
    var getInfo = function() {
        var wrapper = $.ezdia.getWrapper('ez-js-sys-fine-upload-info-wrapper');
        var template = $.ezdia.template.get('base-form-upload-info');  
        var content = template(this);
                
        wrapper.html(content).dialog({
            modal: true,
            title: 'File information',
            width: 400,
            height: 300,    
            buttons: [{
                text: "Close",
                class: 'btn-link',
                click: function() {
                    $( this ).dialog( "close" );
                }
            }]
        });        
    };
    
    var setInfo = function(obj) {
        this.find('[data-link="info"]').on('click', getInfo.bind(obj));
    };
        
    var setFileUrl = function(obj) {
        obj.name = obj.name || obj.thumbnailUrl;
        var ext = obj.name.split('.').pop();
        var imgurl = obj.thumbnailUrl;
        var urlLink = this.find('[data-link="url"]');
        var urlImg= this.find('img.qq-thumbnail-selector.original');
            
        if ($.inArray(ext.toLowerCase(), imgExtension) === -1) {
            urlImg.hide()
                .next('img')
                .addClass('show')
                .closest('li.qq-upload-success')
                .addClass('qq-upload-file-type')
                .find('[data-type="qq-file-ext"]').text(ext);
            
            urlLink.remove();
            obj.type = 'file';
        } else {
            obj.type = 'image';
            urlLink.attr('href', imgurl);
        }     
                
    };
    
    var updateUploadBtnStatus = function() {
        var cls = 'ez-qq-uploaded-limit-exceeds';
        var wrapper = $(this._options.element).find('.qq-gallery');
        if(this._currentItemLimit === this._netUploaded) {
            wrapper.addClass(cls);
        } else {
            wrapper.removeClass(cls);
        }      
    };
    
    var setValue = function (elem, values) {
        values = JSON.stringify(values);
        elem.val(values).trigger('change');
        
        if (this._currentItemLimit) {
            updateUploadBtnStatus.call(this);
        }
    };
    
    var addUrl = function(name, value) {
        var wrapper = $('#ui_' + name);
        
        $.each(value, function(i, obj){
            var elem = wrapper.find('.qq-file-id-' + i);
            
            if (elem.length) {
                setFileUrl.call(elem, obj);
                setInfo.call(elem, obj);
            }
        });
        
    }; 
    
    var addVal = function (valsObj) {
        var id = valsObj.id;
        var responseObj = valsObj.responseObj;
        var name = valsObj.name;
        var elem = $(this._options.ui_element);
        var value = elem.val();
        var arr = $.ezdia.getJsonObject(value) || [];
        var item = this.getItemByFileId(id);
        var $item = $(item);
        var obj =  {
            uuid: responseObj.newUuid,
            name: name,
            thumbnailUrl: responseObj.thumbnailUrl,
            size: this.getSize(id),
            role: responseObj.role,
            username: responseObj.username
        };    
        
        this.setUuid(id, obj.uuid);
        
        arr.push(obj);
        
        $item.data('uuid', obj.uuid);
        setFileUrl.call($item, obj);
        setInfo.call($item, obj);
        setValue.call(this, elem, arr);
    };
    
    var deleteVal = function (index, uuid) {
        var arr = [];
        var values = '';
        var elem = null;
        
        if (!uuid) {
            return;
        }
        
        elem = $(this._options.ui_element);
        values = elem.val();
        arr = $.ezdia.getJsonObject(values) || [];
        
        arr[index]['status'] = 'deleted';
        this._netUploaded -= 1;
        this._netUploadedOrQueued -= 1;
        setValue.call(this, elem, arr);
        
    };
    
    var onComplete = function(id, name, responseObj, xhr) {
        if (responseObj.success) {
            addVal.call(this, {
                id: id, 
                name: name,
                responseObj: responseObj
            });
        } else {
        }
        
    };
    
    var onSubmitDelete = function (id) {
        deleteDialog.call(this, id);
        return false;
    };
    
    var onError = function(id, name, errorReason, xhrOrXdr){
        var wrapper = $.ezdia.getWrapper('ez-js-sys-fine-upload-error-wrapper');
        
        wrapper.html(errorReason).dialog({
            modal: true,
            title: 'File upload error',
            width: 400,
            height: 200,    
            buttons: [{
                text: "Close",
                class: 'btn-link',
                click: function() {
                    $( this ).dialog( "close" );
                }
            }]
        });
    };
    
    var updateDeletedCls = function (item) {
        item.find('.qq-upload-status-text-selector').text('Deleted');
        item.removeClass('qq-upload-success');
        item.addClass('qq-upload-delete');
    };
    
    var deletes = function (id) {
        var item = this.getItemByFileId(id);
        var uuid = '';
        
        if (!item) {
            return;
        }
        
        item = $(item);
        uuid = this.getUuid(id);
        
        deleteVal.call(this, id, uuid);
        updateDeletedCls(item);
        
    };
    
    var deleteDialog = function (id) {
        var self = this;
        var name = this.getName(id);
        var item = $(this.getItemByFileId(id));
        var context = {
            msg: 'Are you sure you want to delete this file?',
            name: name,
            size: item.find('.qq-upload-size-selector').text(),
            src: item.find('img.qq-thumbnail-selector:visible').attr('src')
        };
        deletetemplate = $.ezdia.template.get('base-form-upload-delete-popover');
        var content = deletetemplate(context);
        var wrapper = getWrapper();
        
        wrapper.html(content).dialog({
            modal: true,
            title: 'Delete File',
            width: 450,
            height: 250,
            buttons: [{
                text: "Cancel",
                class: 'btn-link',
                click: function() {
                    $( this ).dialog( "close" );
                }            
            }, {
                text: "Delete",
                click: function() {
                    deletes.call(self, id);
                    $( this ).dialog( "close" );
                }            
            }]
        });
    };
    
    var updateStatus = function(name, value) {
        var elem = $('#ui_' + name);
        
        $.each(value, function(i, obj){
            if (obj.status == 'deleted') {
                var item = elem.find('.qq-file-id-' + i);
                
                if (item.length) {
                    updateDeletedCls(item);
                }
                
            }
        });
    };
    
    var readonly = function (name) {
        var elem = $(elements).addClass('qq-gallery-viewonly');
        
        $('[name="'+ name +'"]').remove();
        elem.find('.qq-upload-button').remove();
        
    };
    
    var getFieldValue = function(obj) {
        var column = obj.column;
        var value = obj.value || $('[name='+ column.name +']').val() || null;
        
        
        if (value && typeof value === 'string') {
            value = $.ezdia.getJsonObject(value);
        }
        
        return value;
    }; 
    var addImageByUrl = function (name, url) {
        var pageParams = $.ezdia.config.pageParams || {};
        var userName = pageParams.userName;
        var uploader = this.getUploader(name);
        var elem = $(uploader._options.ui_element);
        var value = elem.val();
        var jsonVal = $.ezdia.getJsonObject(value) || [];
        
        var arr = url.split('?');
        var filename =  arr[0].split("/").pop();

        // TODO: REMOVE FIX THIS ONCE NEW CODE IS IMPLEMENTED
        if (!userName) {
          userName = ezdia.config.user.name
        }
       
	jsonVal.push({
            uuid: "img",
            name: filename,
            thumbnailUrl: url,
            size: "",
            role: pageParams.role || $('#role').val() || "",
            username: pageParams.userName || ""
        });
        
        setValue.call(this, elem, jsonVal);  
        
        this.refresh({
            name: name,
            value: jsonVal
        });
    };
    
    var checkMaxLimit = function(uploader) {
        var validation = uploader._options.validation;
        var elem = $(uploader._options.ui_element);
        var val = $.ezdia.getJsonObject(elem.val());
        
        var returnVal = true;

        if (val && validation.itemLimit && validation.itemLimit <= val.length) {
            returnVal = false;
        }
          
        return returnVal;
    };
    
    var getFileFromUrl = function (url, validation) {
        var arr = url.split('?');
        var filename =  arr[0].split("/").pop();
        var ext = filename.split('.').pop();
        var fileExt = imgExtension;
        
        if (validation.allowedExtensions.length) {
            fileExt = validation.allowedExtensions;
        }
        
        if (!filename) {
            alert("File upload error", "No image file found.");
            filename = null; 
        } else if ($.inArray(ext.toLowerCase(), fileExt) === -1) {
            alert("File upload error", filename + " has an invalid extension. Valid extension(s): " + fileExt.join(", "));
            filename = null;
        }
        
        return filename;
    };
    
    var openDialogForUrlPanel = function(name, validation) {
        var _this = this;
        var wrapper = $.ezdia.getWrapper("ez-qq-paste-image-warapper");
        var frmTemplate = $.ezdia.template.get('base-form-paste-image-url');  
        var input;
        
        wrapper.html(frmTemplate);
        frm = wrapper.find('form');
        input = wrapper.find('input');
        
        frm.validate({
            errorClass: "text-danger",
            errorElement: "span",
            rules: {
                ez_qq_paste_image_url: {
                    required: true,
                    url: true
                }
            }
        });   
        
        wrapper.dialog({
            resizable: false,
            modal: true,
            title: "Paste image URL",
            width: 500,
            height: 200,
            buttons: [{
                text: "Cancel",
                class: 'btn-link',
                click: function() {
                    $( this ).dialog( "close" );
                }
            }, {
                text: 'Add',
                class: 'btn-primary',
                click: function(){
                    
                    if (!frm.valid()) {
                        return;
                    }
                    
                    var url = input.val();
                    var filename = getFileFromUrl(url, validation);
                    
                    if (!filename) {
                        return;
                    }
                    
                    addImageByUrl.call(_this, name, url);
                    $( this ).dialog( "close" );
                }
            }]
        });
    };
    
    function removeUplaodByUrl(settingsObj) {
        var wrapper = $(settingsObj.element).find('.qq-uploader-selector').addClass('ez-only-sys-upload');
        wrapper.find('.qq-sep-text').remove();
        wrapper.find('.qq-url-button').remove();
    }
    
    $.extend(this, {
        upload: {
            uploaders: {},
            defaults: {
                template: 'qq-template-gallery',
                request: {
                    endpoint: 'ImageUpload.htm',
                    inputName: 'upload'
                },
                deleteFile: {
                    enabled: true
                },
                thumbnails: {
                    placeholders: {
                        notAvailablePath: '../style/images/fineNotFound.png'
                    }
                },
                callbacks: {
                    onComplete: onComplete,
                    onSubmitDelete: onSubmitDelete,
                    onError: onError
                },
                showMessage: function(){}
            },
            init: function(entityObject, obj){
                var column = obj.column;
                var name = column.name;
                
                entityObject[name] = obj;
                
                return this.view(obj);    
            },
            create: function(uploadObject){
                var self = this;
                
                $.each(uploadObject, function(name, obj){
                    var column = obj.column;
                    var config = column.config || {};
                    var settingsObj = getOptions.call(self, name, obj);
                    var value = getFieldValue(obj);
                            
                    var uploader = new qq.FineUploader(settingsObj);
                    
                    self.uploaders[name] = uploader;
                    
                    $('[qq-button-id=' + uploader._defaultButtonId + ']').removeAttr('title');
                    
                    if (value && value.length) {
                        uploader.addInitialFiles(value);
                        addUrl(name, value);
                    }
                    
                    if (!column.editable) {
                        readonly();
                        removeUplaodByUrl(settingsObj);
                    } else if(config.disableByUrl) {
                        removeUplaodByUrl(settingsObj);
                    } else {
                        self.uplaodByUrl.bind.call(self, column);
                    }
                    
                });
            },
            view: function(obj){    
                var column = obj.column;
                var input = '';
                var context = '';
                var value;
                var template = '';
                
                if (obj.preview) {
                    value = $.ezdia.getJsonObject(obj.value);
                    
                    if (!$.isEmptyObject(value)) {
                        template = $.ezdia.template.get('base-form-upload-local-view');
                        context = template(value);
                    } else {
                        context = '';
                    }
                } else {
                    input = $.ezdia.inputs.textarea(obj, true);
                    context = '<div id="ui_'+ column.name +'"></div>';
                }
                return input + context;
            },
            uplaodByUrl: {
                bind: function (column) {
                    var _this = this;
                    $('#ui_' + column.name).find('.qq-url-button').on('click', function() {
                        _this.uplaodByUrl.action.call(_this, column.name);
                    });
                },
                action: function(name) {
                    var _this = this;
                    var uploader = this.getUploader(name);
                    
                    if (!uploader) {
                        return;
                    }
                    //console.log(uploader._options.validation.allowedExtensions)
                    if (checkMaxLimit(uploader)) {
                        openDialogForUrlPanel.call(_this, name, uploader._options.validation);
                    } else {
                        alert("File upload error", "Too many items would be uploaded. Item limit is " + uploader._options.validation.itemLimit);
                    }
                }
            },
            getUploader: function(name) {
                return this.uploaders[name];
            },
            refresh: function (obj) {
                var uploadObject = {};
                var name = obj.name;
                var uploader = this.getUploader(name);
                var elem;
                
                if (!uploader) {
                    return;
                }
                
                obj.value = $.ezdia.getJsonObject(obj.value);
                
                uploadObject[name] = {
                    column: uploader._options.ui_column,
                    value: obj.value
                };
                
                this.create(uploadObject, true);
                
                elem = $(uploader._options.ui_element);
                
                updateStatus(name, obj.value); 
                
                setValue.call(uploader, elem, obj.value);
            },
            formatter: function(cm){
                var self = this;
                cm.formatter = function(v) {
                    var content = self.view({
                        preview: true,
                        value: v
                    });
                    
                    return '<div class="col-max-height">' + content + '<textarea style="display: none">' + v + '</textarea></div>';
                };
                cm.unformat = function(v, o, cell) {
                    
                    return $(cell).find('textarea').val();
                };
            }
        }
    });
}).apply($.ezdia, [jQuery]);


(function($){
    var catObj = {};
    
    var setLabel = function(name, value) {   
        
        if (value == catObj.id) {
            $('#ez-js-sys-display-' + name).html(catObj.name);
        }
        
    };
    
    $.extend(this, {
        category: {
            init: function(initObject, obj){
                var column = obj.column;
                var name = column.name;
                
                initObject[name] = obj;
            },
            create: function(initObject){
                var metaInfo = $.ezdia.config.metaObj || {};
                catObj = metaInfo.category;
                
                $.each(initObject, function(name, obj){
                    var column = obj.column;
                    var id = '';
                    
                    if (column.editable) {
                        id = $('#' + (column.id || name));
                        id.category(obj);
                    } else {
                        setLabel(column.name, obj.value);
                    }
                });
            },
            view: function (obj) {
                var column = obj.column;
                var content = '';
                
                if (column.editable) {
                    content = $.ezdia.inputs.textboxs(obj);
                } else {
                    content = $.ezdia.inputs.hiddentext(obj) + '<span id="ez-js-sys-display-'+ column.name +'">'+ obj.value +'</span>';
                }
                
                return content;
            }
        }
    });
}).apply($.ezdia, [jQuery]);

(function($){
    
    var id_prefix = 'ez_js_sys_variation_';
    var cls_disabled = 'disabled';
    
    var variationsLink = function(name) {
        var template = $.ezdia.template.get('base-form-field-action-link');
        
        return template({
            name: name,
            variation: {
                id: id_prefix + name
            }
        });
    };
    
    var variationsWrap = function(name) {
        
        return $('<div>', {
            id: id_prefix + 'wrap_' + name,
            class: 'alert alert-desk-item-status show-history-wrapper ez-segment-variations'
        }).prop('outerHTML');
    };
    
    var variationsErrorWrap = function(name) {
        
        return $('<div>', {
            id: id_prefix + 'error_' + name,
            class: 'alert alert-desk-item-status show-history-wrapper ez-segment-variations'
        }).prop('outerHTML');
    };
    
    var updateVal = function(obj) {
        var config = obj.column.config || {};
        var highlight = config.highlight || {};
        obj.visible_value = obj.value || '';
        
        if (highlight.regex && highlight.wrap) {
            var regex = new RegExp(highlight.regex, "g");
            var matchArray = obj.value.match(regex) || [];
            
            obj.visible_value = obj.value || '';
            
            $.each(matchArray, function(i, reg){
                var exp = $(highlight.wrap).text(reg).prop('outerHTML');
                obj.visible_value = obj.visible_value.replace(reg, exp);
            });
        }
    };
   
    $.extend(this, {
        segment: {
            init: function(initObject, obj){
                var column = obj.column;
                var name = column.name;
                
                initObject[name] = obj;
            },
            create: function(initObject){
                var self = this;
                
                $.each(initObject, function(name, obj){
                    var column = obj.column;
                    var id = '';
                    
                    if (column.editable) {
                        id = $('#' + (column.id || name));
                        id.segments(obj);
                    } else {
                        self.view(obj);
                    }
                });
            },
            view: function (obj) {
                var column = obj.column;
                var content = '';
                
                if (obj.value) {
                    updateVal(obj);
                }
                
                if (column.editable) {                    
                    content = $.ezdia.inputs.textareas(obj);
                    content += variationsWrap(column.name);
                    content += variationsErrorWrap(column.name);
                    content += variationsLink(column.name);
                    
                } else {
                    content = obj.visible_value || obj.value;
                }
                
                return content;
            },
            setValue: function(obj){
                var id = $('[name="' + obj.name + '"]').data('visibleId');
                $('#' + id).segments('setValue', obj.value);
            },
            getValue: function(elem){
                elem.segments('getValue');
            },
            delValue: function(obj) {
                var id = obj.element.data('visibleId');
                var name = obj.element.attr('name');
                var action = obj.action;
                var link = $('#' + id_prefix + name);
                
                $.ezdia.html.toggle(id, action);
                
                if (action) {
                    link.addClass(cls_disabled);
                } else {
                    link.removeClass(cls_disabled);
                }
                
            }
        }
    });
}).apply($.ezdia, [jQuery]);

(function ($, document, window) {
    var prefix = 'ez_js_sys_inline_editor_';
    
    $.extend(this, {
        inline: {
            init: function(initObj, obj) {
                var column = obj.column;

                initObj[column.id || column.name] = obj;

                return this.view(obj);
            },
            create: function(initObj) {
                $.each(initObj, function(key, obj){
                    var column = obj.column;
                    var config = column.config || {};
                    
                    if (config && config.templates) {
                        var id = $('#' + (column.id || column.name));
                        id.inlineEditor(obj);
                    } else {
                        window.console.warn('WARNING: template configuration is missing for ' + column.label);
                    }
                });
            },
            view: function(initObj) {
                var column = initObj.column;
                var content = '';
                var value = initObj.value || '';
                var template = $.ezdia.template.get('base-form-inline-editor');
                var config = column.config || null;
                
                content = template({
                    name: column.name,
                    id: prefix + column.name,
                    value: value,
                    toggle: config && config.config && config.config.toggle
                });
                
                content += $.ezdia.inputs.textarea(initObj, true);
                
                return content;
            },
            setValue: function(obj) {
                var elem = obj.element;
                
                if (!(elem instanceof jQuery)) {
                    elem = $(obj.element);
                }
                
                elem.inlineEditor('setValue', obj.value);
            },
            getValue: function(obj) {
                var elem = obj.element;
                
                if (!(elem instanceof jQuery)) {
                    elem = $(obj.element);
                }
                
                return elem.inlineEditor('getValue');
                
            },
            delValue: function(obj) {
                var elem = obj.element;
                
                if (!(elem instanceof jQuery)) {
                    elem = $(obj.element);
                }
                
                return elem.inlineEditor('setMode', obj.action);
                
            },
            update: function() {
                
            }
        }
    });
}).apply($.ezdia, [jQuery, document, window]);

(function ($) {
    
    var event = function (elem, countWrapper, config) {
                    
        elem.on('count:init change keyup', function() {
            var val = this.value || '';
            
            if (config.char) {
                countWrapper.find('.char').html(val.length);
            }

            if (config.word) {
                var count = val ? val.split(' ').length : 0;
                countWrapper.find('.word').html(count);
            }                    
        });
        
        elem.trigger('count:init');
    };
    
    $.extend(this, {
        inputCount: {
            init: function(initObj, obj) {
                var column = obj.column;

                initObj[column.id || column.name] = obj;
                
            },
            create: function(initObj) {
                $.each(initObj, function(key, obj){
                    var template = $.ezdia.template.get('base-input-count-wrapper');
                    var column = obj.column;
                    var config = column.config || {};
                    var elem = $('[name="'+ column.name + '"]');
                    var row = elem.closest('[data-row="input"]');
                    var countWrapper = row.append(template({
                        char: config.count.char,
                        word: config.count.word,
                        and: config.count.char && config.count.word
                    })).find('.ez-field-count-wrapper');
                    
                    event(elem, countWrapper, config.count);

                });
            }
        }
    });
}).apply($.ezdia, [jQuery]);